// Built @Wed, 27 Dec 2023 03:56:16 GMT
import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty, objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties } from "./_virtual/_rollupPluginBabelHelpers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/esnext.string.at.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.to-fixed.js";
import { log, typeOf, curTimestamp, nowTime, generateSessionId, getHostFromUrl, formatDefinition, computeWatchDur, toJsonString, transformHeader, checkIsBlob, getXhr, checkUrlIsExpired, getPageVisibility, checkVideoSrcIsEmpty, hasClass, isType, getResponseHeaders, formatData, parseTempData } from "./utils/util.js";
import { findPerformanceInfo } from "./utils/connect.js";
import { LOAD_STATES, CACHE_FILE_TYPE, MAX_TIME, FULLSCREEN_TYPE, REPORT_EVENTS, ENDED_TYPE, COMMON_KEYS, MIN_WAITIONG, MAX_COST, MAX_FVT, PLAYBACK_STATE, ERROR_CODES, ERROR_TYPES, MAX_STALL_TIME, LOGTYPES } from "./constant.js";
import LOCAL_LOG from "./utils/locallog.js";
import Browser, { getSupport } from "./utils/browser.js";
import SpeedCheckTask from "./utils/speedtask.js";
import ProgressInfo from "./progress-info.js";
import VERSION from "./version.js";
var _excluded = ["try_req_num", "req_node_succ", "conn_req_num", "has_ret_node", "conn_fail_num", "conn_jump_num"];
log("xgVodLogger version is ".concat(VERSION));
var isObject = isType("Object");
var TEA_ID = 1300;
var LS_KEY = "__tea_cache_tokens_".concat(TEA_ID);
var DEFAULT_INTERVAL = -1;
var AB_SDK_VERSION = "";
var Collector = null;
var XGPlayerAppLogger = /* @__PURE__ */ function() {
  function XGPlayerAppLogger2(_player, options) {
    var _this = this;
    _classCallCheck(this, XGPlayerAppLogger2);
    _defineProperty(this, "initializeUrlLog", function(value) {
      var initialUrl = value && value.url ? value.url : typeOf(value) === "String" ? value : "";
      if (typeOf(initialUrl) !== "String") {
        initialUrl = "";
      }
      _this.urlLog = {
        initial_url: initialUrl,
        initial_host: getHostFromUrl(initialUrl),
        initial_ip: ""
      };
    });
    _defineProperty(this, "onXgLogCache", function() {
      var logstr = _this._getLogCache();
      if (logstr) {
        var _this$player;
        _this._templog = {
          vtype: (_this$player = _this.player) === null || _this$player === void 0 ? void 0 : _this$player.vtype,
          log: logstr
        };
        _this.onOneTemp();
      }
    });
    _defineProperty(this, "onPrfDataSize", function(data) {
      _this._progressInfo.upDateDownload(data);
    });
    _defineProperty(this, "onDegrade", function(info) {
      if (info) {
        info.local_time = (/* @__PURE__ */ new Date()).getTime();
        _this.onOneEvent({
          end_type: "degrade"
        }, info);
      }
    });
    _defineProperty(this, "onMediaFormatError", function(error_info) {
      _this.onOneEvent({
        end_type: "".concat(error_info.error_type || "", "Error")
      });
    });
    _defineProperty(this, "onDrmTypeChange", function(drm_type) {
      _this.addIfExist("drm_type", {
        drm_type
      }, _this._options);
    });
    _defineProperty(this, "onReplayBtnClick", function() {
      _this.resetLoggerParams();
    });
    _defineProperty(this, "onBeforeDefinitionChange", function() {
      _this.resLogs.ldst = nowTime();
      _this._endType = "switch";
    });
    _defineProperty(this, "onDefinitionChangeDetail", function(data) {
      var _progressInfo = _this._progressInfo;
      _progressInfo.updateDefInfo(data, _this.player.currentTime);
      var lastBitrate = _progressInfo.lastBitrate;
      if (lastBitrate && data.mediaType === "video") {
        _this.sendSwitchOpera("changedetail");
      }
    });
    _defineProperty(this, "onDefinitionChange", function(_ref) {
      var from = _ref.from, to = _ref.to;
      _this.changeResolution({
        from,
        to,
        startTime: _this.resLogs.ldst,
        operaType: "switch"
      });
      log("onDefinitionChange from:".concat(from, ", to:").concat(to));
    });
    _defineProperty(this, "onDefiChangeSuccess", function() {
      log("onDefinitionChangeSuccess");
      _this.updateVideoSize();
      _this.triggerTask("start");
    });
    _defineProperty(this, "onAbrChange", function(_ref2) {
      var prev = _ref2.prev, cur = _ref2.cur, abrInfo = _ref2.abrInfo;
      if (_this.player.abrInstance) {
        var data = _this.player.abrInstance.eventInfo;
        log("abrChange", data);
        data.last_definition = prev;
        data.now_definition = cur;
        _this.abrInfo.abr_event_info.video_switch.push(data);
        _this.changeResolution({
          from: prev,
          to: cur,
          startTime: nowTime(),
          operaType: "abr_switch",
          abrInfo
        });
      }
    });
    _defineProperty(this, "onAbrPrestallEnd", function(stop) {
      _this.abrInfo.abr_user_info.cancel_abr = stop ? 1 : 0;
    });
    _defineProperty(this, "onTimeUpdate", function() {
      var playlogs = _this.playlogs, resLogs = _this.resLogs, player = _this.player, errorLog = _this.errorLog;
      errorLog.try_err_c = 0;
      if (!playlogs.vt && _this.startStep === 1) {
        playlogs.vt = curTimestamp();
        log("onTimeUpdate: first frame inited", "currentTime11:".concat(player.currentTime, " vt-pt:").concat(playlogs.vt - playlogs.pt, " vt-nt:").concat(playlogs.vt - playlogs.nt, " vt-rt:").concat(playlogs.vt - playlogs.rt));
        _this.startStep = 2;
      }
      if (!resLogs.initial_resolution) {
        var def = player.currentDefitionFromPlayer && player.currentDefitionFromPlayer.definition ? player.currentDefitionFromPlayer.definition : player.config.defaultDefinition || "".concat(player.video.videoHeight, "p") || "";
        def = formatDefinition(def);
        resLogs.initial_resolution = def;
      }
      if (!resLogs.final_resolution) {
        resLogs.final_resolution = resLogs.initial_resolution;
      }
      var len = playlogs.played.length;
      if (len < 1) {
        playlogs.played.push({
          begin: player.currentTime,
          end: -1
        });
      } else {
        playlogs.played[len - 1].end = player.currentTime;
      }
      _this._progressInfo.updatePlayed(player.currentTime);
      _this._progressInfo.checkNextBitrate(player.currentTime);
      var dLen = resLogs.played.length;
      if (dLen < 1) {
        resLogs.played.push({
          begin: player.currentTime,
          end: -1
        });
      } else {
        resLogs.played[dLen - 1].end = player.currentTime;
      }
      _this.lastVideoTime = player.currentTime || 0;
    });
    _defineProperty(this, "onVideoProgress", function() {
      _this.updateBuffers();
      _this._progressInfo.updateBuffered(_this.player.buffered);
    });
    _defineProperty(this, "onCanplay", function() {
      log("onCanplay", "this.startStep:".concat(_this.startStep, " ").concat(curTimestamp()));
      _this.setVt();
    });
    _defineProperty(this, "onLoadeddata", function() {
      log("onLoadeddata", "this.startStep:".concat(_this.startStep, " ").concat(curTimestamp()));
      _this.setVt();
      _this.updateVideoSize();
    });
    _defineProperty(this, "onLoadStart", function() {
      _this.commonParams.web_url = location.href;
      var isSrcEmpty = checkVideoSrcIsEmpty(_this.player.currentSrc);
      _this.triggerTask("start");
      log("onLoadStart", "this.startStep:".concat(_this.startStep, " ").concat(curTimestamp(), " isSrcEmpty:").concat(isSrcEmpty, " player.src:").concat(_this.player.src));
      if (_this.startStep === 0 && !isSrcEmpty && document.visibilityState === "visible") {
        _this.setPt();
      }
    });
    _defineProperty(this, "onBufferedChange", function() {
      var buffered = _this.player.video && _this.player.video.buffered;
      if (buffered) {
        var len = buffered.length;
        if (len > 0 && buffered.end(len - 1) + 1 > _this.player.duration) {
          _this.bft = curTimestamp();
        }
      }
    });
    _defineProperty(this, "onPlayerInited", function() {
      log("player init");
      _this._playerCreatedTime = curTimestamp();
      _this.playlogs.rt = curTimestamp();
    });
    _defineProperty(this, "onNotAutoPlay", function() {
      log("onNotAutoPlay", "autoplay:".concat(_this.isAutoplay));
      if (_this.isAutoplay === 0) {
        _this.isAutoplay = 2;
      } else if (_this.isAutoplay === 1) {
        _this.isAutoplay = 3;
      }
    });
    _defineProperty(this, "onDashError", function(err) {
      err = err || {};
      var errorLog = _this.errorLog;
      errorLog.last_errors.push(err.errorCode);
      errorLog.accu_errc++;
      _this.onOneError({
        errorType: err.errorTypeCode,
        code: err.errorCode,
        url: err.url || "",
        headers: err.headers || {}
      }, 0);
    });
    _defineProperty(this, "onPlayerError", function(err) {
      err = err || {};
      var errorLog = _this.errorLog, player = _this.player;
      log("onPlayerError", "this.player.type:".concat(_this.player.type, " this.player.replayRunning:").concat(_this.player.replayRunning, " isSupportMP4:").concat(Browser.isSupportMP4, " isPC:").concat(Browser.isPC));
      log("onPlayerError", err);
      _this.load_state = LOAD_STATES.ERROR;
      _this._endType = "error";
      _this.suspendWaitingStatus("onPlayerError");
      _this._progressInfo.calculatePlaySize();
      if (player.type === "dash" && player.replayRunning) {
        return;
      }
      if (!err.url) {
        err.url = _this.player.currentSrc;
      }
      if (Browser.isPC && !Browser.isSupportMP4 || Browser.isSpider) {
        errorLog.errc = ERROR_CODES[5];
        errorLog.errt = ERROR_TYPES.notSupport;
        _this.onOneError({
          errorType: errorLog.errt,
          code: errorLog.errc,
          url: err.url,
          headers: err.headers || {},
          message: err.message || ""
        }, 0);
        _this._isOnePlayReport = true;
        return;
      }
      errorLog.errt = err.errorTypeCode || (err.errorType && ERROR_TYPES[err.errorType] ? ERROR_TYPES[err.errorType] : 9999);
      errorLog.message = err.message || "";
      if (err.errorCode) {
        errorLog.errc = err.errorCode > 0 && ERROR_CODES[err.errorCode] ? ERROR_CODES[err.errorCode] : err.errorCode;
      } else if (err.code) {
        errorLog.errc = err.code > 0 && ERROR_CODES[err.code] ? ERROR_CODES[err.code] : err.code;
      }
      errorLog.last_errors.push(errorLog.errc);
      if (errorLog.fir_errc === 0) {
        errorLog.fir_errc = errorLog.errc;
      }
      _this.sendSwitchOpera(ENDED_TYPE.ERROR);
      _this.onOnePlay(ENDED_TYPE.ERROR);
      _this.onOneTemp(ENDED_TYPE.ERROR);
      _this.sendDegradeLog("playCatch_end", _this.playlogs.degrade);
      var needCheck = false;
      var orgError = err.mediaError;
      if (orgError && _this._options.needXhrCheck && (orgError.code === 4 || orgError === 2)) {
        needCheck = true;
      }
      _this.onOneError({
        endState: ENDED_TYPE.PLAY_ERROR,
        errorType: errorLog.errt,
        code: errorLog.errc,
        url: err.url,
        headers: err.headers || {},
        message: err.message || ""
      }, 0, needCheck);
      _this.sendEventsQueue();
    });
    _defineProperty(this, "onPlayInterfaceInfo", function(info) {
      log("onPlayInterfaceInfo", info);
      var errorLog = _this.errorLog, apiLog = _this.apiLog, playlogs = _this.playlogs;
      if (info) {
        Object.keys(info).map(function(key) {
          if (key === "code") {
            apiLog.vsc = info[key];
          } else if (key === "message") {
            apiLog.vsc_message = info.message || "success，视频可正常播放";
          } else {
            apiLog[key] = info[key];
          }
        });
      }
      playlogs.at = info.timestamep || (/* @__PURE__ */ new Date()).getTime();
      if (info.error && info.error.errc === -9988) {
        return;
      }
      apiLog.vsc = info.code || 10;
      apiLog.vsc_message = info.message || "success，视频可正常播放";
      if (info.error) {
        var error = info.error;
        errorLog.errt = 1e3;
        errorLog.errc = error.errc || -9998;
        errorLog.last_errors.push(error.errc || -9998);
        if (errorLog.fir_errc === 0) {
          errorLog.fir_errc = error.errc || -9998;
        }
        errorLog.accu_errc++;
        if (errorLog.accu_errc === 1) {
          errorLog.fir_errt = nowTime();
        }
        _this.onOneError({
          errorType: 1e3,
          code: error.errc || -9998,
          url: "",
          headers: {}
        });
      }
    });
    _defineProperty(this, "onProgressEvent", function() {
      var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var netLog = _this.netLog;
      if (data.speed) {
        var speed = data.speed > 1e6 ? Math.floor(data.speed / 1e3) : data.speed;
        netLog.downloadSpeed = speed;
        netLog.totalSpeed += speed;
        netLog.rqCount++;
      }
      data.type !== "oversize" && netLog.requestCount++;
      data.connectTime && (netLog.connectCost = data.connectTime);
      var percent = netLog.rqCount < 7 ? 100 : data.costTime >= 5e3 ? 20 : 10;
      if (data.type === "success" && parseInt(Math.random() * 100, 10) <= percent) {
        return;
      }
      var connectData = findPerformanceInfo(data.cdnUrl);
      var xhr = data.xhr || {};
      var type = data.type ? "progress_".concat(data.type) : "progress";
      var headers = data.headers;
      if (!headers) {
        headers = getResponseHeaders(xhr);
      }
      headers = transformHeader(headers);
      var ext = _objectSpread2(_objectSpread2({}, headers), {}, {
        download_speed: netLog.downloadSpeed,
        connect_cost: netLog.connectCost,
        c_dur: connectData.connectDuration || 0,
        d_dur: connectData.domainDuration || 0,
        r_dur: connectData.duration || 0,
        rqtt: (/* @__PURE__ */ new Date()).getTime(),
        x_cache: headers.x_response_cache || "",
        server_ip: headers.x_response_sinfo
      });
      if (data.status) {
        netLog.status = data.status;
      } else if (xhr && xhr instanceof window.XMLHttpRequest) {
        netLog.status = xhr.status || 0;
      }
      ext.status = netLog.status;
      var url = data.cdnUrl || data.url;
      if (data.type === "error") {
        _this.merror.cdn.push(_objectSpread2(_objectSpread2({
          costTime: data.costTime,
          cur_play_pos: data.pos,
          cdn_url: url,
          cdn_host: getHostFromUrl(url)
        }, ext), headers));
      }
      _this.onOneEvent({
        costTime: data.costTime,
        vid: data.vid,
        end_type: type,
        cur_play_pos: data.pos,
        cdn_url: url,
        cdn_host: getHostFromUrl(url)
      }, ext, data.type === "error" ? 0 : 2);
    });
    _defineProperty(this, "onNext", function() {
      log("onNext:startStep:", _this.startStep);
      if (_this.startStep > 0) {
        if (_this._reportInvalidVV(ENDED_TYPE.NEXT)) {
          return;
        }
        _this.sendSwitchOpera(ENDED_TYPE.NEXT);
        _this.onOnePlay(ENDED_TYPE.NEXT);
        _this.onOneTemp(ENDED_TYPE.NEXT);
        _this.sendEventsQueue();
      }
      _this.vtype = null;
      _this.playlogs.lc = 0;
      _this.resetLoggerParams();
    });
    _defineProperty(this, "onNextEnded", function() {
      var player = _this.player, resLogs = _this.resLogs;
      var idf = formatDefinition(player.config.defaultDefinition || "");
      resLogs.initial_resolution = idf;
      resLogs.final_resolution = idf;
    });
    _defineProperty(this, "onXgLogWaiting", function(data) {
      var playlogs = _this.playlogs, resLogs = _this.resLogs, stall = _this.stall, _options = _this._options;
      if (!_options.checkByInnerLog || data.type !== 0) {
        return;
      }
      log("onXgLogWaiting", data);
      var endType = data.endType, costTime = data.costTime, start = data.start;
      var extParams = {
        download_speed: _this.realSpeed,
        avg_speed: _this.avgSpeed,
        mse_op: _this.mp4MseOpLength,
        mp4_load_range: _this.mp4LoadSegmentTimeRange,
        bitrate: _this.curBitrate
      };
      if (data.eventType === "waitingStart") {
        _this.onOneEvent({
          costTime,
          end_type: "waitstart"
        }, extParams, 2);
        _this.appendStallInfo("start", start);
        return;
      }
      if (data.eventType === "waitingEnd") {
        var now = nowTime();
        log("onXgLogWaiting>>".concat(endType, "|costTime:").concat(costTime, "  vt:").concat(playlogs.vt));
        _this.appendStallInfo("end", now, endType);
        playlogs.bc++;
        if (_this.checkInBuffer(_this.player.currentTime)) {
          playlogs.de_bu_acu_t += costTime;
          playlogs.dbc++;
        } else {
          playlogs.nbc++;
          playlogs.n_bu_acu_t += costTime;
        }
        resLogs.bc++;
        playlogs.bu_acu_t += costTime;
        resLogs.bu_acu_t += costTime;
        stall.end = _this.cur_play_pos;
        stall.cost = costTime;
        stall.acc += stall.cost;
        if (stall.sc === 1) {
          stall.endf = _this.cur_play_pos;
        }
        _this.onOneEvent({
          costTime,
          end_type: "waitend"
        }, extParams, 2);
      }
    });
    _defineProperty(this, "onSeeking", function() {
      if (checkVideoSrcIsEmpty(_this.player.src)) {
        return;
      }
      var resLogs = _this.resLogs, playlogs = _this.playlogs, player = _this.player, seekLog = _this.seekLog;
      log("onSeeking", "currentTime:".concat(player.currentTime));
      if (_this.startStep === 0) {
        _this.setPt();
      }
      _this.suspendWaitingStatus("seek");
      _this.isSeeking && _this.suspendSeekStatus("seek", false);
      _this.isSeeking = true;
      playlogs.played.push({
        begin: player.currentTime,
        end: -1
      });
      resLogs.played.push({
        begin: player.currentTime,
        end: -1
      });
      _this._progressInfo.updatePlayed(player.currentTime, 0);
      seekLog.lastSeekStartTime = nowTime();
      seekLog.seekBefore = _this.lastVideoTime.toString();
      seekLog.buf_include = _this.checkInBuffer(_this.player.currentTime) ? 1 : 0, seekLog.intervalId = setTimeout(function() {
        if (_this.isSeeking) {
          _this.suspendSeekStatus("seekTimeout", true);
        }
      }, MAX_STALL_TIME);
    });
    _defineProperty(this, "onSeeked", function() {
      if (checkVideoSrcIsEmpty(_this.player.src)) {
        return;
      }
      if (_this.isSeeking) {
        _this.suspendSeekStatus("seeked", true);
      }
    });
    _defineProperty(this, "onPlaying", function() {
      _this.suspendWaitingStatus("play");
      _this.load_state = LOAD_STATES.PLAYABLE;
      var now = nowTime();
      if (_this.pauseLog.isPausing) {
        _this.pauseLog.isPausing = false;
        _this.pauseLog.pause_acu_t += now - _this.pauseLog.pause_start;
      }
    });
    _defineProperty(this, "onPlayCatch", function(type) {
      var error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        errorType: "",
        errorTypeCode: 0,
        errorCode: 0,
        url: "",
        headers: {},
        status: 0
      };
      log("onPlayCatch", type, error);
      if (!type) {
        return;
      }
      switch (type) {
        case "mp42dash":
          _this.vtype = "DASH_2";
          break;
        case "dash2mp4":
          _this.vtype = "MP4_2";
          break;
        case "dash1mp4":
          _this.vtype = "MP4_1";
          break;
        default:
          _this.vtype = type;
      }
      var errorLog = _this.errorLog, playlogs = _this.playlogs, merror = _this.merror;
      merror.playCatch.push(_objectSpread2({
        errc: error.errorCode,
        errt: error.errorType
      }, error.headers));
      _this.setBr("playcatch");
      errorLog.accu_errc++;
      errorLog.try_err_c++;
      errorLog.fir_errc = error.errorCode;
      error.errorCode && errorLog.last_errors.push(error.errorCode);
      _this.suspendWaitingStatus("playcatch");
      _this.suspendSeekStatus("playcatch");
      _this.sendDegradeLog("playCatch", playlogs.degrade, {
        cdn_url: error.url
      });
      playlogs.degrade = type;
      _this.onOneError({
        errorType: error.errorTypeCode,
        code: error.errorCode,
        url: error.url || "",
        status: error.httpCode || error.status,
        headers: error.headers || {},
        vid: error.vid || _this.vid,
        preload_hit: error.preloadHit || 0,
        preload_cached: error.preloadCached || 0,
        endState: ENDED_TYPE.PLAY_CATCH,
        costTime: error.costTime,
        message: error.errorMessage || error.message,
        interval_time: error.timerStep || 0
      }, 0);
    });
    _defineProperty(this, "onMediaExpied", function() {
      var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        errorType: "",
        errorTypeCode: 0,
        errorCode: 0,
        url: "",
        headers: {},
        status: 0
      };
      var errorLog = _this.errorLog, playlogs = _this.playlogs;
      log("onMediaExpied", error);
      _this.suspendWaitingStatus("expied");
      _this.setBr("expied");
      errorLog.accu_errc++;
      errorLog.try_err_c++;
      errorLog.last_errors.push(error.errorCode);
      playlogs.at = (/* @__PURE__ */ new Date()).getTime();
      _this.merror.expied.push(_objectSpread2({
        errorType: error.errorTypeCode || error.errorType,
        code: error.errorCode,
        url: error.url || "",
        status: error.status
      }, transformHeader(error.headers || {})));
      _this.onOneError({
        errorType: error.errorTypeCode || error.errorType,
        code: error.errorCode,
        url: error.url || "",
        status: error.status,
        headers: error.headers || {}
      }, 0);
    });
    _defineProperty(this, "onLog", function(data) {
      log("onLog", data);
      var type = data.type;
      delete data.type;
      if (!type) {
        return;
      }
      switch (type) {
        case LOGTYPES.RETRY:
          break;
        case LOGTYPES.ONETEMP:
          if (!_this._templog) {
            _this._templog = {};
          }
          _this._templog = parseTempData(_this._templog, data.data, data.action);
          if (_this._templog.preload_hit) {
            _this._cacheFile = CACHE_FILE_TYPE.CACHED;
          }
          break;
        case LOGTYPES.ONEERROR:
          var errorLog = _this.errorLog;
          errorLog.accu_errc++;
          errorLog.try_err_c++;
          _this.setBr("mp4error");
          errorLog.last_errors.push(data.code);
          _this.onOneError(data, 0);
          break;
        case LOGTYPES.ONEEVENT:
          var ret = formatData(data, {
            costTime: "costTime",
            vid: "vid",
            end_type: "end_type",
            pos: "cur_play_pos",
            cdnUrl: "cdn_url"
          });
          if (ret.ext) {
            ["start", "end"].map(function(key) {
              if (ret.ext[key]) {
                ret.ext["ext_".concat(key)] = ret.ext[key];
                delete ret.ext[key];
              }
            });
          }
          _this.onOneEvent(ret.data, ret.ext, 2);
          break;
      }
    });
    _defineProperty(this, "onPlay", function() {
      log("onPlay", "this.startStep :".concat(_this.startStep, " this.isEnded:").concat(_this.isEnded));
      if (_this.isEnded) {
        _this.resetLoggerParams();
        _this.setPt();
      }
    });
    _defineProperty(this, "onPause", function() {
      log("onPause");
      var pauseLog = _this.pauseLog;
      pauseLog.isPausing = true;
      pauseLog.pause_start = nowTime();
    });
    _defineProperty(this, "onWaiting", function() {
      var _options = _this._options;
      _this.updateCurBuffer("onWaiting");
      if (_options.checkByInnerLog) {
        return;
      }
      log("onWaiting>", "isSeeking:".concat(_this.isSeeking, " startStep:").concat(_this.startStep, " intervalId:").concat(_this.stallIntervalId));
      _this.wait_buf_include = _this.checkInBuffer(_this.player.currentTime, -1e3) ? 1 : 0;
      if (_this.isSeeking || _this.playlogs.vt === 0) {
        return;
      }
      if (_this.inWaitingStart > 0) {
        return;
      }
      if (_this.stallIntervalId) {
        window.clearTimeout(_this.stallIntervalId);
        _this.stallIntervalId = null;
      }
      _this.inWaitingStart = nowTime();
      _this.waitStartTime = _this.cur_play_pos;
      _this.stallIntervalId = window.setTimeout(function() {
        var stall = _this.stall;
        log("this.stallIntervalId>>".concat(_this.stallIntervalId, " cost: ").concat(nowTime() - _this.inWaitingStart));
        _this._endType = "wait";
        _this.load_state = LOAD_STATES.STALLED;
        if (_this.vtype.indexOf("MP4") > -1 && _this.player.currentTime > 10 && _this.task) {
          _this.triggerTask("waiting", _this.initial_url);
          _this.requestCount++;
        }
        stall.start = _this.waitStartTime;
        stall.bc++;
        if (stall.bc === 1) {
          stall.startf = _this.waitStartTime;
        }
        window.clearTimeout(_this.stallIntervalId);
        _this.stallIntervalId = null;
        _this.startWaitingStatus(_this.inWaitingStart, nowTime() - _this.inWaitingStart);
        _this.stallIntervalId = setTimeout(function() {
          if (_this.inWaitingStart > 0) {
            _this.suspendWaitingStatus("timeout");
          }
        }, MAX_STALL_TIME);
      }, MIN_WAITIONG);
    });
    _defineProperty(this, "onEnded", function() {
      if (!_this.initial_url) {
        return;
      }
      log("onEnded", "watchDur:".concat(_this.watchDur, " vt:").concat(_this.vt, " pt:").concat(_this.pt));
      _this.isEnded = true;
      var df = _this.resLogs.df;
      var _progressInfo = _this._progressInfo;
      _progressInfo.calculatePlaySize();
      if (_progressInfo.cachedSize < 1) {
        _this.changeResolution({
          from: df,
          to: df,
          startTime: nowTime(),
          operaType: "leave_switch",
          endType: "ended"
        });
      } else {
        _this.sendSwitchOpera(ENDED_TYPE.ENDED);
      }
      _this.onOnePlay(ENDED_TYPE.ENDED);
      _this.sendDegradeLog("playCatch_end", _this.playlogs.degrade);
      _this.onOneTemp(ENDED_TYPE.ENDED);
      _this.sendEventsQueue();
      _this.playlogs.lc++;
    });
    _defineProperty(this, "onUnload", function() {
      if (_this.startStep === 0 || !_this.initial_url) {
        return;
      }
      _this.onOneTemp(ENDED_TYPE.UNLOAD);
      _this.sendDegradeLog("playCatch_end", _this.playlogs.degrade);
      if (_this._reportInvalidVV(ENDED_TYPE.UNLOAD)) {
        return;
      }
      _this.sendSwitchOpera(ENDED_TYPE.UNLOAD);
      _this.onOnePlay(ENDED_TYPE.UNLOAD, true);
    });
    _defineProperty(this, "onVisibilitychange", function() {
      var vt = _this.playlogs.vt;
      if (document.visibilityState === "visible") {
        if (!vt) {
          _this.setPt();
        }
      }
    });
    _defineProperty(this, "onDestroy", function() {
      log("onDestroy:this.startStep:".concat(_this.startStep, " initial_url:").concat(_this.initial_url, " ").concat(!!_this.initial_url));
      _this.onOnePlay(ENDED_TYPE.DESTROY);
      if (_this.startStep > 0 && _this.initial_url) {
        _this.onOneTemp(ENDED_TYPE.DESTROY);
        _this.sendDegradeLog("playCatch_end", _this.playlogs.degrade);
      }
      var df = _this.resLogs.df;
      if (_this._progressInfo.cachedSize < 1) {
        _this.changeResolution({
          from: df,
          to: df,
          startTime: nowTime(),
          operaType: "leave_switch",
          endType: "destroy"
        });
      } else {
        _this.sendSwitchOpera(ENDED_TYPE.ENDED);
      }
      _this.sendEventsQueue();
      if (Browser.isPC) {
        window.removeEventListener("beforeunload", _this.onUnload);
      } else if (Browser.isMobile || Browser.isPad) {
        window.removeEventListener("pagehide", _this.onUnload);
      }
      document.removeEventListener("visibilitychange", _this.onVisibilitychange);
      _this.listeners.forEach(function(item) {
        _this.player.off(item.evt, item.handler);
      });
      _this.clearTimers();
      _this.player.off("destroy", _this.onDestroy);
      _this.task && _this.task.clear();
    });
    _defineProperty(this, "onOnePlay", function() {
      var endState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3;
      var isLeave = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      log("onOnePlay _isOnePlayReport:".concat(_this._isOnePlayReport, " isLeave: ").concat(isLeave, " endState:").concat(endState));
      if (_this._isOnePlayReport) {
        return;
      }
      var errorLog = _this.errorLog, playlogs = _this.playlogs, abrInfo = _this.abrInfo, resLogs = _this.resLogs, player = _this.player, apiLog = _this.apiLog, pauseLog = _this.pauseLog, stall = _this.stall, netLog = _this.netLog, watchDur = _this.watchDur;
      _this._isOnePlayReport = true;
      var et = curTimestamp();
      _this.getBufferTime(player);
      var frameInfo = _this.getFrameInfo();
      var _perf = _this.getPerformance();
      var _errCode = errorLog.errc;
      var _this$_progressInfo = _this._progressInfo, playedSize = _this$_progressInfo.playedSize, cachedSize = _this$_progressInfo.cachedSize, pcdnCached = _this$_progressInfo.pcdnCached, cachedVideoSize = _this$_progressInfo.cachedVideoSize, pcdnVideoCached = _this$_progressInfo.pcdnVideoCached;
      var fileSize = _this._progressInfo.getFileSize(player.duration);
      _this.setExt();
      var params = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        local_time: (/* @__PURE__ */ new Date()).getTime(),
        log_type: "video_playq",
        // 是否有插件加载异常，0是正常 1为异常
        plugin_exception: 0,
        // todo
        // 自研播放器创建异常
        player_create_exception: "",
        // todo
        v: _this.vid,
        // video id，外部传入
        initial_url: _this.initial_url,
        initial_host: _this.initial_host,
        initial_ip: _this.curHeaders.x_response_sinfo || 0,
        initial_type: _this.initial_type
      }, _this.curHeaders), {}, {
        initial_resolution: resLogs.initial_resolution,
        final_resolution: resLogs.final_resolution,
        // play_timestamp,  用户启动本次播放的时间戳
        pt: _this.pt,
        // prepare开始的时间戳，单位是毫秒
        prepare_start_time: playlogs.nt,
        // 暂时用启动播放时间戳
        // prepare结束时间戳
        prepare_end_time: playlogs.rt || curTimestamp(),
        // 暂时用启动播放时间戳
        // vv_time,  用户开始看到点播视频的第一帧画面的时间戳
        vt: _this.vt,
        // wp_time用户没有播放点播视频就离开的时间，若未发生则是空,LWP（leave  without play），单位是毫秒
        lt: _this.lt,
        // lpt lt与pt的差值，用于统计复用下未起播快速切换
        lpt: _this.lpt,
        // 首帧耗时
        fvt: _this.fvt,
        // 初始化到首帧的耗时
        nvt: _this.nvt,
        // buffer  finish time用户本次点播视频流加载结束的时间戳，单位是毫秒
        bft: _this.bft,
        // 用户本次点播视频流加载结束时间戳
        // seek的次数
        sc: _this.seekLog.sc,
        // 累计seek时长
        sat: _this.seekLog.sat,
        // 网络卡顿次数，即出现Loading的次数，只统计main url的bc
        bc: _this.bc,
        dbc: playlogs.dbc || 0,
        nbc: playlogs.nbc || 0,
        video_net_s: _this.videoNetworkState,
        status: _this.curStatus,
        // 第一次发生卡顿的时间
        first_buf_startt: stall.startf,
        // 第一次卡顿结束时间
        first_buf_endt: stall.endf,
        lc: playlogs.lc,
        // 循环播放次数为0
        // 累积网络卡顿时长
        bu_acu_t: _this.bu_acu_t > MAX_TIME ? 0 : _this.bu_acu_t,
        de_bu_acu_t: playlogs.de_bu_acu_t || 0,
        n_bu_acu_t: playlogs.n_bu_acu_t || 0,
        // 累积暂停时长
        pause_acu_t: pauseLog.pause_acu_t,
        // 退出时播放时播放进度, 单位毫秒
        cur_play_pos: _this.cur_play_pos,
        // 退出时当前的加载状态(卡顿与否)
        load_state: _this.load_state,
        // 当前倍速
        play_speed: _this.playbackRate,
        // 退出时的播放状态
        playback_state: _this.playback_state,
        // 结束类型
        end_state: endState,
        // 累积观看时长
        watch_dur: watchDur > MAX_TIME ? 0 : watchDur,
        // 切换清晰度的次数
        switch_resolution_c: _this.switchResolutionCount,
        // 是否在onprepared之后自动start 是否自动播放
        is_start_play_automatically: _this.isAutoplay,
        // 视频续播时的起始位置（用户上次看到的位置），单位ms
        start_time: _this.start_time,
        // 是否播放完成
        finish: _this.finish,
        // error_type，最终的错误类型，服务端据此统计总的失败率  0 无错误 1000 Play接口错误 1001 DNS错误 1002 Player内部错误 1003 CDN错误 9999 其他错误
        errt: errorLog.errt,
        // 最终错误码
        errc: _errCode,
        // video status code  视频状态异常，play接口返回的视频状态码（0或者10为正常状态）
        vsc: apiLog.vsc,
        // play接口返回的视频状态异常信息
        vsc_message: errorLog.message || apiLog.vsc_message,
        api_str: apiLog.api_str,
        // api请求链接
        auth: apiLog.auth || apiLog.logid,
        // api请求非时候token或者logid
        width: _this.videoWidth,
        height: _this.videoHeight,
        // 视频时长
        vd: _this.vd,
        video_length: fileSize.video,
        audio_length: fileSize.audio,
        // 视频清晰度
        df: _this.resolution,
        // 视频当前清晰度
        lf: resLogs.lf,
        play_c: 0,
        // 本次setVideoID/DirectURL/..中的play次数写为0
        // 播放器实例创建完成时间
        player_created_t: _this.player_created_t,
        // 抽刺出错时间
        fir_errt: errorLog.fir_errt,
        // 首次出错错误码
        fir_errc: errorLog.fir_errc,
        lv_method: 0,
        // 离开时调用的方式  "0 stop, 1 release, 2 release  async ,3 normal 4 error , 5 status excp ,6 reset"
        // 最后一次切换分辨率开始时间
        ldst: resLogs.ldst,
        // 最后一次切换分辨率完成时间
        ldet: resLogs.ldet,
        is_disable_short_seek: 0,
        // 播放器目前没有short_seek处理
        mute: _this.mute,
        volume: _this.volume,
        download_speed: _this.realSpeed ? _this.realSpeed : _this.task && _this.task.speed ? _this.task.speed : netLog.downloadSpeed,
        avg_speed: _this.avgSpeed ? _this.avgSpeed : netLog.rqCount > 0 ? parseInt(netLog.totalSpeed / netLog.rqCount, 10) : 0,
        bitrate: _this.curBitrate,
        // 当前视频码率
        preload_state: _this.preloadState,
        // 预加载状态，0没有 1队列中 2当前正在预加载
        preload_hit: _this.preLoadData.hit || 0,
        // 是否命中预加载
        preload_cached: _this.preLoadData.duration || _this.preLoadData.byteLength || 0,
        // 预加载数据查长度
        mdl_req_num: netLog.requestCount,
        // 网络请求次数
        watingcost: _this.watingCost,
        br: playlogs.br,
        // 中断次数
        fbrt: playlogs.fbrt,
        // 第一次中断
        try_err_c: errorLog.try_err_c,
        // 重试次数
        accu_errc: errorLog.accu_errc,
        // 累计错误次数
        // eagleid: this.eagleid,
        merror: toJsonString(_this.merror),
        ex: toJsonString(_this.exInfo),
        perf: toJsonString(_perf),
        bufs: toJsonString(_this.buffers.allBuffer),
        vds: cachedSize,
        pvds: pcdnCached,
        vps: playedSize,
        vvds: cachedVideoSize,
        // dash 进一步区分video带宽
        pvvds: pcdnVideoCached,
        // dash 进一步分区video pcdn带宽
        // pcdn连接数据
        pcdn: toJsonString(_this.getPCDNStat())
      }, _this.buffers.curBuffer), {}, {
        degrade: playlogs.degrade,
        cache_file: _this._cacheFile
      }, frameInfo), {}, {
        fullScreen: _this._getFullScreenType(),
        encryptedInfo: toJsonString(_this.encryptedInfo)
      });
      if (_this.vt !== 0) {
        params.et = et;
      }
      var logstr = _this._logstrcache || _this._getLogCache();
      if (params.fvt === 0 && logstr) {
        params.log = logstr;
        _this._logstrcache = null;
      }
      if (player !== null && player !== void 0 && player.softDecoder) {
        params.soft_decoder = player.softDecoder;
      }
      if (player && player.dashState) {
        params.dash_state = player.dashState;
      }
      if (player !== null && player !== void 0 && player.softDecoder) {
        params.soft_decoder = player.softDecoder;
      }
      abrInfo.abr_init_opts = player.config.autoBitrateOpts || {};
      params.abr_info = toJsonString(_this.abrInfo);
      if (isLeave) {
        var _isLocal = !_this._options.disableLocalCache;
        _this.reportLog(REPORT_EVENTS.ONE_PLAY, params, _isLocal ? 1 : 0);
      } else {
        _this.reportLog(REPORT_EVENTS.ONE_PLAY, params);
      }
    });
    _defineProperty(this, "onOneEvent", function(_ref3) {
      var costTime = _ref3.costTime, vid = _ref3.vid, end_type = _ref3.end_type, cur_play_pos = _ref3.cur_play_pos, cdn_url = _ref3.cdn_url, cdn_host = _ref3.cdn_host;
      var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var mode = arguments.length > 2 ? arguments[2] : void 0;
      log("onOneEvent", end_type);
      var _this$buffers = _this.buffers, curBuffer = _this$buffers.curBuffer, allBuffer = _this$buffers.allBuffer;
      var frameInfo = _this.getFrameInfo();
      var params = _objectSpread2(_objectSpread2({
        local_time: (/* @__PURE__ */ new Date()).getTime(),
        // video id，外部传入
        v: vid || _this.vid,
        // 耗时
        cost_time: costTime,
        // 结束类型seek、switch、exit、wait、error、progress
        end_type: end_type || _this.end_type,
        // 当前cdn地址
        cdn_url: cdn_url || _this.url,
        cdn_host: cdn_host || "",
        initial_type: _this.initial_type,
        resolution: _this.resolution,
        // 当前倍速
        play_speed: _this.playbackRate,
        // 距离起播时间间隔
        first_frame_interval: nowTime() - _this.pt,
        // 距离上次切清晰度的时间间隔
        last_switch_interval: _this.getLastInterval("lastSwitchStartTime", _this.resLogs, false),
        // 距离上次seek操作的时间间隔
        last_seek_interval: _this.updateSeekPt(false),
        // 上次同类型事件的时间间隔
        last_event_interval: _this.getLastInterval("lastEventTime"),
        // 时间发生时视频进度
        cur_play_pos: cur_play_pos || _this.cur_play_pos,
        video_ready_s: _this.videoReadyState,
        video_seeking: _this.videoSeeking,
        video_paused: _this.videoPaused,
        bufs: toJsonString(allBuffer),
        // 内部重试次数
        retry_count: _this._retryCount,
        // 目前播放器没有重试逻辑
        at: _this.playlogs.at,
        // 初始化时间戳
        bc: _this.stall.bc,
        // 记录当前发生过几次卡顿
        stay_seconds: parseInt(((/* @__PURE__ */ new Date()).getTime() - _this.playlogs.at) / 1e3, 10),
        preload_state: _this.preloadState,
        // 预加载状态，0没有 1队列中 2当前正在预加载
        preload_hit: _this.preLoadData.hit,
        // 是否命中预加载
        preload_cached: _this.preLoadData.duration || _this.preLoadData.byteLength
      }, curBuffer), frameInfo);
      if (end_type.indexOf("waitend") >= 0 && costTime > 3e3) {
        params.log = _this._getLogCache();
      }
      var _this$player2 = _this.player, currentTime = _this$player2.currentTime, duration = _this$player2.duration;
      var diff = duration - currentTime;
      if (end_type.indexOf("waitstart") >= 0 && diff <= 1) {
        var local_time = params.local_time, v = params.v, cost_time = params.cost_time, _cdn_url = params.cdn_url, first_frame_interval = params.first_frame_interval, _cur_play_pos = params.cur_play_pos, video_ready_s = params.video_ready_s, video_seeking = params.video_seeking, video_paused = params.video_paused, bufs = params.bufs, bc = params.bc, preload_hit = params.preload_hit;
        _this.reportLog(REPORT_EVENTS.ONE_EVENT, _objectSpread2({
          end_type: "longwait",
          local_time,
          v,
          cost_time,
          cdn_url: _cdn_url,
          first_frame_interval,
          cur_play_pos: _cur_play_pos,
          video_ready_s,
          video_seeking,
          video_paused,
          bufs,
          bc,
          preload_hit
        }, curBuffer), mode);
      }
      if (end_type === "waitstart" && typeof _this._options.getPageFPS === "function") {
        var fpsInfo = _this._options.getPageFPS();
        params.cur_fps = fpsInfo.curFPS || 0;
        params.avg_fps = fpsInfo.avgFPS || 0;
      }
      if (end_type.indexOf("wait") > -1) {
        params.buf_include = _this.wait_buf_include;
      }
      if (end_type.indexOf("timeout") > -1) {
        if (params.cost_time > MAX_COST) {
          params.cost_time = MAX_COST;
        }
      }
      var player = _this.player;
      if (player && player.dashState) {
        params.dash_state = _this.player.dashState;
      }
      Object.keys(ext).forEach(function(key) {
        params[key] = ext[key];
      });
      params.ex = toJsonString(_this.getPlayerExt());
      _this.addIfExist("drm_type", _this._options, params);
      _this.reportLog(REPORT_EVENTS.ONE_EVENT, params, mode);
    });
    _defineProperty(this, "onOneTemp", function() {
      log("onOneTemp>>", !_this._templog);
      if (!_this._templog) {
        return;
      }
      var player = _this.player, playlogs = _this.playlogs, pauseLog = _this.pauseLog, errorLog = _this.errorLog, resLogs = _this.resLogs, watchDur = _this.watchDur;
      var params = _objectSpread2(_objectSpread2(_objectSpread2({
        local_time: (/* @__PURE__ */ new Date()).getTime()
      }, _this._templog), {}, {
        v: _this.vid,
        // video id，外部传入
        initial_type: _this.initial_type,
        // 初始起播类型
        // play_timestamp,  用户启动本次播放的时间戳
        pt: _this.pt,
        // vv_time,  用户开始看到点播视频的第一帧画面的时间戳
        vt: _this.vt,
        // wp_time用户没有播放点播视频就离开的时间，若未发生则是空,LWP（leave  without play），单位是毫秒
        lt: _this.lt,
        // 首帧耗时
        fvt: _this.fvt,
        // 网络卡顿次数，即出现Loading的次数，只统计main url的bc
        bc: _this.bc,
        // 第一次发生卡顿的时间
        // 累积网络卡顿时长
        bu_acu_t: _this.bu_acu_t > MAX_TIME ? 0 : _this.bu_acu_t,
        // 累积暂停时长
        pause_acu_t: pauseLog.pause_acu_t,
        // 退出时播放时播放进度, 单位毫秒
        cur_play_pos: _this.cur_play_pos,
        // 累积观看时长
        watch_dur: watchDur > MAX_TIME ? 0 : watchDur,
        // 是否播放完成
        finish: _this.finish,
        // error_type，最终的错误类型，服务端据此统计总的失败率  0 无错误 1000 Play接口错误 1001 DNS错误 1002 Player内部错误 1003 CDN错误 9999 其他错误
        errt: errorLog.errt,
        // 最终错误码
        errc: errorLog.errc,
        // 视频时长
        vd: _this.vd,
        // 视频清晰度
        df: _this.resolution,
        // 视频当前清晰度
        lf: resLogs.lf,
        br: playlogs.br,
        // 中断次数
        fbrt: playlogs.fbrt,
        // 第一次中断
        try_err_c: errorLog.try_err_c,
        // 重试次数
        accu_errc: errorLog.accu_errc,
        // 累计错误次数
        dash_break: player.dashBufferBreak === 2 ? 1 : 0,
        bufs: toJsonString(_this.buffers.allBuffer),
        vs: resLogs.vs,
        vds: resLogs.vds,
        vps: resLogs.vps
      }, _this.buffers.curBuffer), {}, {
        degrade: playlogs.degrade
      });
      if (_this.vt !== 0) {
        params.et = curTimestamp();
      }
      ["drm_type", "dynamic_type"].forEach(function(key) {
        _this.addIfExist(key, _this._options, params);
      });
      _this.reportLog(REPORT_EVENTS.ONE_TEMP, params, 0);
      _this._templog = null;
    });
    this.player = _player;
    if (this.player === void 0 || this.player === null) {
      throw new Error("player is ".concat(this.player));
    }
    if (!options || !options.line_app_id) {
      console.warn("player.config.vodLogOpts.line_app_id is necessary for plugin xgVodLogger");
      return;
    }
    options.isTask && (this.task = new SpeedCheckTask());
    this.eventQueue = [];
    this._instanceCreateTime = (/* @__PURE__ */ new Date()).getTime();
    options.codec_type = options.codec_type || "h264";
    this._envInfo = options.envInfo || {};
    this._options = options;
    !this._options.maxQueueCount && (this._options.maxQueueCount = 5);
    this.line_app_id = parseInt(options.line_app_id, 10) || 0;
    this.line_user_id = (options.line_user_id || "").toString();
    this.playerCoreVersion = _player.version;
    this.playerVersion = options.playerVersion;
    this.closeSeekLog = options.closeSeekLog || false;
    this.start_time = (options.start_time || 0) * 1e3;
    this._initial_resolution = "";
    this.__vtype = null;
    this.__dt = "";
    this._progressInfo = new ProgressInfo();
    this.resetLoggerParams();
    try {
      this.initializeTracker();
      this.sendLocalLog();
      this.bindEvt();
      log("logger constructor:".concat(this.player.video));
    } catch (e) {
      console.error(e);
    }
  }
  _createClass(XGPlayerAppLogger2, [{
    key: "resetLoggerParams",
    value: function resetLoggerParams() {
      log("resetLoggerParams");
      var lc = this.playlogs ? this.playlogs.lc : 0;
      this.playlogs = {
        nt: curTimestamp(),
        // sdk初始化的时间点
        vt: 0,
        // 起播时间
        rt: this.isEnded ? curTimestamp() : 0,
        // 播放器准备完成时间
        at: 0,
        // api_time,  play接口获取视频列表结束的时间戳，单位是毫秒；
        pt: 0,
        // 触发播放流程时间 (this.isEnded || this.player.config.autoplay) ? new Date().getTime() : 0,
        bu_acu_t: 0,
        // 累计网络卡顿时长
        bc: 0,
        // 网络卡顿次数
        br: 0,
        // 中断次数
        fbrt: "",
        // 首次中断类型
        dbc: 0,
        // 解码卡顿次数
        de_bu_acu_t: 0,
        // 累计解码卡顿时长
        nbc: 0,
        // 网络卡顿次数
        n_bu_acu_t: 0,
        // 累计网络请求卡顿时长
        played: [{
          begin: 0,
          end: -1
        }],
        // 累计播放记录
        degrade: "none",
        // 降级类型 dash2dash_backup-dash备用地址降级 mp42dash-mp4降级为dash dash2mp4-dash降级mp4
        lc
      };
      this.degradeLog = {
        bu_acu_t: 0,
        bc: 0,
        watch_dur: 0,
        hasSendEnd: false
      };
      this.buffers = {
        allBuffer: [],
        curBuffer: {
          buf_diff: 0,
          buf_s_pos: 0,
          // 缓存开始点
          buf_e_pos: 0,
          // 缓存结束点
          buf_include: 0
          // 当前缓存是否包含当前播放时间
        }
      };
      this.netLog = {
        downloadSpeed: 0,
        // 网络请求速度
        requestCount: 0,
        // 网络请求次数
        connectCost: 0,
        // 平均网络连接耗时 ms
        totalSpeed: 0,
        // 下载速度累加
        rqCount: 0,
        // 一次播放行为中
        status: 0
        // 最后一次请求的httpcode
      };
      this.merror = {
        // "针对main url的错误信息
        cdn: [],
        // 请求失败的cdn信息
        player: [],
        //  //main_url的player失败信息 // ijk 播放失败
        playCatch: [],
        expied: []
      };
      this.exInfo = {
        stall: []
        // 卡顿信息
      };
      this._templog = null;
      this._isOnePlayReport = false;
      this.startStep = 0;
      this.bft = 0;
      this._progressInfo.reset();
      this.initializeLogDatas();
      this.initializeUrlLog();
    }
  }, {
    key: "initializeLogDatas",
    value: function initializeLogDatas() {
      this.startStep = 0;
      this.inWaitingStart = 0;
      this.waitStartTime = 0;
      this.lastVideoTime = 0;
      this._endType = "";
      this._retryCount = 0;
      this.lastOperaTime = DEFAULT_INTERVAL;
      this.lastEventTime = DEFAULT_INTERVAL;
      this.stallIntervalId = null;
      this.seekLog = {
        intervalId: 0,
        lastSeekStartTime: nowTime(),
        seekBefore: 0,
        sat: 0,
        // 累计seek时长
        sc: 0,
        // seek的次数
        buf_include: 0
      };
      this.resLogs = {
        lastSwitchStartTime: DEFAULT_INTERVAL,
        // 上一次切换清晰度的时间戳
        switch_count: 0,
        // 切换次数
        abr_switch_count: 0,
        initial_resolution: "",
        // 初始清晰度
        final_resolution: "",
        // 最终清晰度
        ldst: 0,
        // 最后一次切换分辨率开始时间
        ldet: 0,
        // 最后一次切换分辨率完成时间
        df: "",
        // 清晰度
        lf: "",
        // 切换前清晰度
        played: [],
        bc: 0,
        // 累计卡顿次数
        bu_acu_t: 0,
        sc: 0,
        // 累计seek次数
        sat: 0,
        // 累计seek耗时
        buf: 0,
        // 累计缓存时长
        lbuf: 0,
        // 上一次缓存的时长
        lplayed: 0,
        // 上一个清洗播放的时长
        vs: 0,
        // 当前视频大小
        vds: 0,
        // 当前下载大小
        vps: 0,
        // 当前播放过的数据大小
        vis: 0,
        // vs/duration
        bitrate: 0
        // 比特率
      };
      this.apiLog = {
        code: 0,
        message: "",
        logid: "",
        api: "",
        auth: "",
        error: {}
      };
      this.errorLog = {
        accu_errc: 0,
        // 累计错误次数
        try_err_c: 0,
        // 错误重试次数，重试成功清零
        errt: 0,
        errc: 0,
        fir_errt: 0,
        fir_errc: !Browser.isSupportMP4 ? 1005 : 0,
        // 试验 暂用字段
        last_errors: [],
        message: ""
      };
      this.pauseLog = {
        pause_acu_t: 0,
        // 累计暂停时长
        isPausing: false,
        pause_start: 0
      };
      this.stall = {
        sc: 0,
        startf: 0,
        // 第一次卡顿开始时间点
        endf: 0,
        // 第一次卡顿结束时间点
        start: 0,
        // 最后一次卡顿开始时间
        end: 0,
        // 最后一次卡顿结束时间
        cost: 0,
        // 最近一次stall时长
        acc: 0
        // 多次累计
      };
      this._playerCreatedTime = 0;
      this.load_state = LOAD_STATES.UNKNOWN;
      this.lv_method = 6;
      this.isSeeking = false;
      this.isEnded = false;
      this.startStep = 0;
      this.isAutoplay = this.player.config && this.player.config.autoplay ? 1 : 0;
      this.abrInfo = {
        abr_general_info: {},
        abr_event_info: {
          video_switch: [],
          video_stall: [],
          video_exit: {}
        },
        abr_play_info: {
          start_play_time_ms: 0,
          is_hint: 0,
          playback_info: {
            internet_speed_record: [],
            play_bitrate_record: [],
            buffer_length_record: [],
            play_speed_record: []
          }
        },
        abr_user_info: {
          cancel_abr: 0
        },
        abr_init_opts: this.player.config.autoBitrateOpts || {}
      };
      this._cacheFile = CACHE_FILE_TYPE.NO_CACHE;
    }
  }, {
    key: "initSessionId",
    value: function initSessionId() {
      var webId = "0";
      try {
        var data = window.localStorage.getItem(LS_KEY);
        webId = data.web_id || "0";
      } catch (error) {
        webId = "0";
      }
      this._sessionId = generateSessionId(webId);
      log("sessionId ".concat(this._sessionId));
    }
  }, {
    key: "initializeTracker",
    value: function initializeTracker() {
      var _this2 = this;
      var _options = this._options;
      if (!window.__xgplayer_vod_log__) {
        this.tracker = window.__xgplayer_vod_log__ = new Collector("tracker");
        var channel = _options.channel || "cn";
        channel = channel === "va" || channel === "sg" ? channel : "cn";
        var config = {
          app_id: channel === "cn" ? TEA_ID : TEA_ID === 1300 ? 323254 : TEA_ID,
          // app_id: channel === 'cn' ? TEA_ID : (TEA_ID === 1300 ? 3063 : TEA_ID),
          channel,
          log: false,
          disable_sdk_monitor: true
        };
        if (_options.channelDomain) {
          config.channel_domain = _options.channelDomain;
        }
        config.enable_ab_test = !!_options.enableAbTest;
        this.tracker.init(config);
      } else {
        this.tracker = window.__xgplayer_vod_log__;
      }
      this.initSessionId();
      var hCore = navigator ? navigator.hardwareConcurrency : 0;
      var mSize = navigator ? navigator.deviceMemory : 0;
      this.commonParams = {
        play_type: 0,
        // 点播
        source_type: "vid",
        sdk_version: VERSION,
        pc: this.playerCoreVersion,
        pv: this.playerVersion,
        line_app_id: this.line_app_id,
        line_user_id: this.line_user_id,
        app_version: _options.appVersion || "",
        platform: Browser.isPad ? "pad" : Browser.isMobile ? "mobile" : "pc",
        // 平台类型
        cpu_core: Number(hCore) || 0,
        memory_size: Number(mSize) || 0,
        support: getSupport(),
        webdriver: navigator && navigator.webdriver ? 1 : 0,
        player_sessionid: this.sessionId,
        web_url: window.location.href,
        user_agent: navigator.userAgent
      };
      var custom = _options.trackerConfig || {};
      log("commonParams ", this.commonParams, custom);
      var trackConfig = _objectSpread2({
        evtParams: this.commonParams,
        disable_auto_pv: true
      }, custom);
      if (Browser.name && !Browser.isChrome && !Browser.isSafari) {
        trackConfig.browser = Browser.name;
        Browser.appVersion && (trackConfig.browser_version = Browser.appVersion);
      }
      if (this.line_user_id) {
        trackConfig.user_unique_id = this.line_user_id;
        trackConfig.web_id = this.line_user_id;
      }
      if (_options.referrer) {
        trackConfig.referrer = _options.referrer;
        trackConfig.referrer_host = getHostFromUrl(_options.referrer);
      }
      if (_options.ext) {
        Object.keys(_options.ext).map(function(key) {
          _this2.exInfo[key] = _options.ext[key];
        });
      }
      log("trackConfig", trackConfig);
      this.tracker.config(trackConfig);
      this.tracker.start();
    }
  }, {
    key: "resetDefiInfo",
    value: function resetDefiInfo() {
      var resLogs = this.resLogs;
      resLogs.played = [];
      resLogs.bc = 0;
      resLogs.bu_acu_t = 0;
      resLogs.sc = 0;
      resLogs.sat = 0;
    }
    /**
     * 初始化的时候将本地记录的日志内容发出去,并将当前记录的内容移除
     */
  }, {
    key: "sendLocalLog",
    value: function sendLocalLog() {
      var _this3 = this;
      var data = LOCAL_LOG.get();
      LOCAL_LOG.remove();
      data.map(function(item) {
        Object.keys(item).map(function(key) {
          log("sendLocalLog", key, item[key]);
          if (_this3.player) {
            _this3.player.emit("abLog", key, item[key]);
            var sendLocalCallback = _this3._options.sendLocalCallback;
            if (sendLocalCallback && typeof sendLocalCallback === "function") {
              sendLocalCallback(key, item[key]);
            }
          }
          _this3._track(key, item[key]);
        });
      });
    }
  }, {
    key: "_track",
    value: function _track(evtName, params) {
      if (typeof this.tracker === "function") {
        this.tracker(evtName, params);
      } else {
        this.tracker.event(evtName, params);
      }
    }
  }, {
    key: "bindEvt",
    value: function bindEvt() {
      var _this4 = this;
      this.listeners = [
        {
          evt: "play",
          handler: this.onPlay
        },
        {
          evt: "playing",
          handler: this.onPlaying
        },
        {
          evt: "pause",
          handler: this.onPause
        },
        {
          evt: "waiting",
          handler: this.onWaiting
        },
        {
          evt: "playInterfaceInfo",
          handler: this.onPlayInterfaceInfo
        },
        {
          evt: "DRM_ERROR",
          handler: this.onDashError
        },
        {
          evt: "ended",
          handler: this.onEnded
        },
        {
          evt: "loadeddata",
          handler: this.onLoadeddata
        },
        {
          evt: "loadstart",
          handler: this.onLoadStart
        },
        {
          evt: "canplay",
          handler: this.onCanplay
        },
        {
          evt: "progress",
          handler: this.onVideoProgress
        },
        // { evt: 'mp4StateChange', handler: this.onMp4StateChange },
        {
          evt: "autoplay_was_prevented",
          handler: this.onNotAutoPlay
        },
        // { 'evt': 'routechange', handler: this.onUserLeave },
        {
          evt: "seeking",
          handler: this.onSeeking
        },
        {
          evt: "seeked",
          handler: this.onSeeked
        },
        {
          evt: "complete",
          handler: this.onPlayerInited
        },
        {
          evt: "timeupdate",
          handler: this.onTimeUpdate
        },
        {
          evt: "bufferedChange",
          handler: this.onBufferedChange
        },
        {
          evt: "beforeDefinitionChange",
          handler: this.onBeforeDefinitionChange
        },
        {
          evt: "definitionChange",
          handler: this.onDefinitionChange
        },
        // 清晰度改变
        {
          evt: "definitionChangeSuccess",
          handler: this.onDefiChangeSuccess
        },
        // 清晰度改变
        {
          evt: "drmTypeChange",
          handler: this.onDrmTypeChange
        },
        // drm_type改变
        {
          evt: "replayBtnClick",
          handler: this.onReplayBtnClick
        },
        // 重播是否处理
        {
          evt: "initialUrl",
          handler: this.initializeUrlLog
        },
        {
          evt: "ABR_CHANGE",
          handler: this.onAbrChange
        },
        // ABR 自动档位发生变化，进行日志记录
        {
          evt: "playCatch",
          handler: this.onPlayCatch
        },
        // { evt: 'MEDIA_EXPIRED', handler: this.onMediaExpied },
        {
          evt: "log",
          handler: this.onLog
        },
        // {'evt':'ABR_LOOP', handler: this.onAbrLoop}, //ABR 抽样记录abr每次调用参数
        {
          evt: "ABR_PRESTALL_END",
          handler: this.onAbrPrestallEnd
        },
        // abr档位第一次码率下降后，用户操作结果
        {
          evt: "progress_event",
          handler: this.onProgressEvent
        },
        {
          evt: "logger_next",
          handler: this.onNext
        },
        {
          evt: "playnext",
          handler: this.onNext
        },
        {
          evt: "nextEnded",
          handler: this.onNextEnded
        },
        {
          evt: "media_format_error",
          handler: this.onMediaFormatError
        },
        {
          evt: "xglog",
          handler: this.onXgLogWaiting
        },
        {
          evt: "xglog_cache",
          handler: this.onXgLogCache
        },
        {
          evt: "degrade",
          handler: this.onDegrade
        },
        {
          evt: "definitionChangeDetail",
          handler: this.onDefinitionChangeDetail
        },
        {
          evt: "prf_data_size",
          handler: this.onPrfDataSize
        }
      ];
      var errorKey = this.player.config.errorKey;
      log(">>>errorKey", errorKey);
      var errorEvt = {
        evt: "error",
        handler: this.onPlayerError
      };
      if (errorKey) {
        errorEvt.evt = errorKey;
      }
      this.listeners.push(errorEvt);
      this.listeners.forEach(function(item) {
        _this4.player.on(item.evt, item.handler);
      });
      this.bindUnload();
    }
  }, {
    key: "_getLogCache",
    value: function _getLogCache() {
      var _this$player3, _this$player4;
      var logstr = ((_this$player3 = this.player) === null || _this$player3 === void 0 ? void 0 : _this$player3.logCache) || ((_this$player4 = this.player) === null || _this$player4 === void 0 ? void 0 : _this$player4.getLogCache);
      this._logstrcache = logstr;
      return logstr;
    }
  }, {
    key: "addIfExist",
    value: function addIfExist(paramsKey, context, params) {
      if (!isObject(context)) {
        return;
      }
      var val = context[paramsKey];
      var isExist = !(val === void 0 || val === null);
      if (isExist) {
        params[paramsKey] = val;
      }
    }
  }, {
    key: "sendSwitchOpera",
    value: function sendSwitchOpera(endType) {
      var _this$_progressInfo2 = this._progressInfo, lastBitrate = _this$_progressInfo2.lastBitrate, curBitrate = _this$_progressInfo2.curBitrate, nextBitrate = _this$_progressInfo2.nextBitrate;
      var data = {
        costTime: 0,
        operaType: "detail_switch",
        stateBefore: "",
        stateAfter: "",
        endType
      };
      var info = null;
      if (endType === "changedetail") {
        if (!lastBitrate) {
          return;
        }
        info = lastBitrate;
        data.stateBefore = lastBitrate.definition;
        data.stateAfter = nextBitrate.definition;
      } else {
        info = curBitrate;
        data.stateBefore = curBitrate.definition;
        data.stateAfter = "";
      }
      var ext = {
        vds: info.cdnSize,
        pvds: info.pcdnSize,
        fileid: info.fileid
      };
      this.onOneOperator(data, ext);
    }
  }, {
    key: "changeResolution",
    value: function changeResolution(_ref4) {
      var from = _ref4.from, to = _ref4.to, startTime = _ref4.startTime, operaType = _ref4.operaType, abrInfo = _ref4.abrInfo, _ref4$endType = _ref4.endType, endType = _ref4$endType === void 0 ? "" : _ref4$endType;
      var resLogs = this.resLogs;
      from = formatDefinition(from);
      to = formatDefinition(to);
      resLogs.ldet = nowTime();
      resLogs.df = to;
      resLogs.lf = from;
      resLogs.final_resolution = to;
      resLogs.switch_count++;
      var costTime = resLogs.ldet - startTime;
      var ext = {
        bc: resLogs.bc,
        bu_acu_t: resLogs.bu_acu_t,
        sc: resLogs.sc,
        sat: resLogs.sat,
        watch_dur: computeWatchDur(resLogs.played)
      };
      if (abrInfo) {
        ext.abrInfo = abrInfo;
      }
      this.updateVds();
      this.resetDefiInfo();
      if (!this._options.closeResolutionLog) {
        this.onOneOperator({
          costTime,
          operaType,
          endType,
          stateBefore: from,
          stateAfter: to
        }, ext, 0);
      }
    }
  }, {
    key: "getLastInterval",
    value: (
      // 获取操作间隔,单位ms
      function getLastInterval(key) {
        var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
        var refresh = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var val = context[key];
        var now = nowTime();
        var lastInterval = val === DEFAULT_INTERVAL ? DEFAULT_INTERVAL : now - val;
        if (refresh) {
          context[key] = now;
        }
        return lastInterval;
      }
    )
  }, {
    key: "updateSeekPt",
    value: function updateSeekPt(refresh) {
      return this.getLastInterval("lastSeekStartTime", this.seekLog, refresh);
    }
  }, {
    key: "_reportInvalidVV",
    value: (
      /**
       *未起播，网络状态码为-1
       */
      function _reportInvalidVV(endState) {
        if (this._isInvaidVV()) {
          this.onOneError({
            endState,
            errorType: 9998,
            code: -1,
            url: this.player.currentSrc,
            headers: {}
          }, 0);
          this._isOnePlayReport = true;
          return true;
        }
        return false;
      }
    )
  }, {
    key: "_isInvaidVV",
    value: function _isInvaidVV() {
      return this.vt === 0 && this.curStatus === -1;
    }
  }, {
    key: "bindUnload",
    value: function bindUnload() {
      if (Browser.isPC) {
        window.addEventListener("beforeunload", this.onUnload);
      } else if (Browser.isMobile || Browser.isPad) {
        window.addEventListener("pagehide", this.onUnload);
      }
      document.addEventListener("visibilitychange", this.onVisibilitychange);
      this.player.once("destroy", this.onDestroy);
    }
  }, {
    key: "clearTimers",
    value: function clearTimers() {
      var seekLog = this.seekLog;
      seekLog.intervalId && window.clearTimeout(seekLog.intervalId);
      this.stallIntervalId && window.clearTimeout(this.stallIntervalId);
    }
    /**
     *
     * @param {string} endType 结束理性 playcatch-发生降级 playcatch-降级播放结束
     * @param {string} degrade 降级类型
     * @param {object} data 附加数据
     */
  }, {
    key: "sendDegradeLog",
    value: function sendDegradeLog() {
      var endType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "playCatch";
      var degrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
      var data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      log("sendDegradeLog", endType, degrade, data);
      var degradeLog = this.degradeLog;
      if (degradeLog.hasSendEnd || endType === "playCatch_end" && degrade === "none") {
        return;
      }
      if (endType === "playCatch_end") {
        degradeLog.hasSendEnd = true;
      }
      var bu_acu_t = this.bu_acu_t - degradeLog.bu_acu_t;
      this.onOneEvent({
        costTime: this.vd,
        vid: this.vid,
        end_type: endType,
        // 'playcatch',
        cur_play_pos: this.player.currentTime,
        cdn_url: data.url
      }, _objectSpread2({
        degrade,
        vt: this.vt,
        pt: this.pt,
        fvt: this.fvt,
        bc: this.bc - degradeLog.bc,
        bu_acu_t: bu_acu_t > MAX_TIME ? 0 : bu_acu_t,
        watch_dur: this.watchDur - degradeLog.watch_dur
      }, data), 0);
    }
  }, {
    key: "_getFullScreenType",
    value: function _getFullScreenType() {
      if (this.player.isFullscreen) {
        return FULLSCREEN_TYPE.FULLSCREEN_TYPE;
      } else if (this.player.isCssfullScreen) {
        return FULLSCREEN_TYPE.CSS;
      }
      return FULLSCREEN_TYPE.NO_FULLSCREEN;
    }
  }, {
    key: "getBufferTime",
    value: function getBufferTime(player) {
      var videoBufferTime = 0;
      var audioBufferTime = 0;
      var buffered = player.video && player.video.buffered;
      if (buffered) {
        var len = buffered.length;
        var cachedBufferTime = 0;
        for (var i = 0; i < len; i++) {
          cachedBufferTime += buffered.end(i) - buffered.start(i);
        }
        videoBufferTime = audioBufferTime = cachedBufferTime * 1e3;
      }
      return {
        video: videoBufferTime,
        audio: audioBufferTime
      };
    }
  }, {
    key: "updateAbrInfo",
    value: function updateAbrInfo(abrInfo, abrInst, playbackRate) {
      abrInfo.abr_general_info = abrInst.generalInfo;
      abrInfo.abr_event_info.video_exit = {
        local_time_ms: (/* @__PURE__ */ new Date()).getTime(),
        buffer_length: abrInst.bufferLength,
        internet_speed: abrInst.downloadSpeed,
        now_bitrate: abrInst.nowBitrate,
        play_speed: playbackRate
      };
      if (abrInst.getAbrPlayInfo) {
        abrInfo.abr_play_info = abrInst.getAbrPlayInfo();
      }
    }
    // 性能统计
  }, {
    key: "getPerformance",
    value: function getPerformance() {
      return this.player.performance || {};
    }
    // 其他补充信息统
  }, {
    key: "setExt",
    value: function setExt() {
      var _this5 = this;
      var ext = this.player.ext || {};
      if (ext.performance) {
        delete ext.performance;
      }
      Object.keys(ext).map(function(key) {
        key !== "performance" && (_this5.exInfo[key] = ext[key]);
      });
    }
    /* 一次用户操作上报 */
    // eslint-disable-next-line camelcase
  }, {
    key: "onOneOperator",
    value: function onOneOperator(_ref5) {
      var costTime = _ref5.costTime, operaType = _ref5.operaType, stateBefore = _ref5.stateBefore, stateAfter = _ref5.stateAfter, endType = _ref5.endType;
      var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
      var last_interval = this.getLastInterval("lastOperaTime");
      var params = {
        local_time: (/* @__PURE__ */ new Date()).getTime(),
        v: this.vid,
        // video id，外部传入
        opera_type: operaType,
        state_before: stateBefore,
        state_after: stateAfter,
        cost_time: costTime,
        end_type: endType || this.end_type,
        cdn_url: this.url,
        resolution: this.resolution,
        last_interval,
        bufs: toJsonString(this.buffers.allBuffer),
        cur_play_pos: this.cur_play_pos,
        // buffer_time: this.buffer_time,
        retry_count: this._retryCount
        // 目前播放器没有重试逻辑
      };
      if (operaType === "seek") {
        params.buf_include = this.seekLog.buf_include;
        this.seekLog.buf_include = 0;
      }
      var player = this.player;
      if (player && player.dashState) {
        params.dash_state = this.player.dashState;
      }
      Object.keys(ext).forEach(function(key) {
        params[key] = ext[key];
      });
      this.addIfExist("drm_type", this._options, params);
      this.reportLog(REPORT_EVENTS.ONE_OPERA, params, mode);
    }
  }, {
    key: "onOneError",
    value: (
      /**
       * 一次错误上报
       * @param {Object} err 错误信息对象
       * type: 0 无错误
       *       1000 Play接口错误
       *       详见 ERROR_TYPES 枚举
       */
      function onOneError() {
        var _this6 = this;
        var err = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
          errorType: 0,
          code: 0,
          url: "",
          headers: {},
          costTime: 0,
          vid: "",
          message: "",
          preload_hit: 0,
          preload_cached: 0,
          interval_time: 0
        };
        var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var needCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        log("onOneError", err);
        var errorLog = this.errorLog, apiLog = this.apiLog, resLogs = this.resLogs, player = this.player, playlogs = this.playlogs;
        var headers = transformHeader(err.headers || {});
        var _perf = this.getPerformance();
        var _errCode = err.code > 0 ? 0 - err.code : err.code;
        this.setExt();
        var params = _objectSpread2(_objectSpread2(_objectSpread2({
          v: err.vid || this.vid,
          // video id，外部传入
          video_pos: this.cur_play_pos,
          local_time: (/* @__PURE__ */ new Date()).getTime(),
          // 耗时
          cost_time: err && err.costTime ? err.costTime : 0,
          errt: err.errorType,
          // 错误类型
          errc: _errCode,
          // 具体的错误码
          es: this.es,
          // error_stage出错时的播放阶段，beforePlay/playing
          cdn_url: err.url || this.url,
          // 出错的url地址
          // cdn_host: /^blob/.test(err.url) ? 'blob:' : getHostFromUrl(err.url),
          bufs: toJsonString(this.buffers.allBuffer),
          // cdn_ip: '', //出错cdn ip
          resolution: resLogs.final_resolution,
          // 出错时的清晰度
          last_errors: errorLog.last_errors.join(";"),
          // 本次播放的所有错误码，用';'分割
          vsc: apiLog.vsc,
          // video status code  视频状态异常，play接口返回的视频状态码（0或者10为正常状态）
          vsc_message: err.message || apiLog.vsc_message,
          // play接口返回的视频状态异常信息
          server_ip: headers.x_response_sinfo || 0,
          initial_url: this.initial_url,
          initial_host: this.initial_host
        }, headers), {}, {
          // cdn服务端返回的client_ip
          cur_play_pos: this.cur_play_pos
        }, this.buffers.curBuffer), {}, {
          degrade: playlogs.degrade,
          end_state: err.endState || ENDED_TYPE.ERROR,
          preload_hit: err.preload_hit || 0,
          preload_cached: err.preload_cached || 0,
          ex: toJsonString(this.exInfo),
          pref: toJsonString(_perf),
          video_ready_s: this.videoReadyState,
          interval_time: err.interval_time || 0
        });
        if (player && player.dashState) {
          params.dash_state = player.dashState;
        }
        var _curSrc = this.player.currentSrc;
        var _u = !checkIsBlob(_curSrc) ? _curSrc : !checkIsBlob(err.url) ? err.url : this.initial_url;
        var snet = {
          connectTime: 0,
          status: 0,
          statusText: "",
          isexpired: 0,
          isBlob: checkIsBlob(_curSrc) ? 1 : 0
        };
        if (needCheck && typeOf(_u) === "String") {
          var net = {};
          getXhr(_u, {
            range: "0-8",
            timeout: 2e3
          }).then(function(data) {
            log("getXhr>>check result ", data);
            var h = transformHeader(data.headers || {});
            params.server_ip = h.x_response_sinfo;
            net = _objectSpread2(_objectSpread2({}, snet), {}, {
              statusText: data.statusText || "",
              status: data.status || 0,
              connectTime: data.connectTime | 0,
              sinfo: h.x_response_sinfo || "",
              cinfo: h.x_response_cinfo || ""
            });
          }).catch(function(e) {
            net = _objectSpread2(_objectSpread2({}, snet), {}, {
              statusText: e.status === -2 ? "timeout" : "error",
              status: e.status
            });
          }).finally(function() {
            var isExpired = checkUrlIsExpired(_u);
            net.isexpired = isExpired;
            params.net = toJsonString(net);
            _this6.reportLog(REPORT_EVENTS.ONE_ERROR, params, mode);
          });
        } else {
          params.net = toJsonString(snet);
          this.reportLog(REPORT_EVENTS.ONE_ERROR, params, mode);
        }
      }
    )
    /**
     * @param {string} evtName
     * @param {any} params
     * @param {number} mode 默认-0:立即发送  1:本地记录 下次发送 2:队列合并发送
     */
  }, {
    key: "reportLog",
    value: function reportLog(evtName, params, mode) {
      var _this7 = this;
      var _options = this._options;
      var ABTestTag = this.player.ABTestTag;
      var commonParams = this.commonParams;
      params.dynamic_type = this.dynamicType;
      var abVersion = typeOf(_options.absdkVersion) === "Array" ? _options.absdkVersion.join(",") : _options.absdkVersion;
      params.absdkVersion = abVersion || XGPlayerAppLogger2.AB_SDK_VERSION;
      ABTestTag !== void 0 && ABTestTag !== null && (params.abtest_tag = ABTestTag);
      var options = this._options;
      params.codec_type = this.codecType;
      if (isObject(options)) {
        COMMON_KEYS.forEach(function(pkey) {
          _this7.addIfExist(pkey, options, params);
        });
        Object.keys(commonParams).forEach(function(key2) {
          _this7.addIfExist(key2, commonParams, params);
        });
        params.vtype = this.vtype;
      }
      params.env_info = toJsonString(this._envInfo || {});
      params.support = getSupport();
      params.visible = getPageVisibility();
      if (mode === 1) {
        var key = evtName;
        var obj = {};
        obj[key] = params;
        LOCAL_LOG.set(obj);
        return;
      } else if (mode === 2) {
        this.addEventsQueue(evtName, params);
        return;
      }
      if (this.player) {
        this.player.emit("abLog", evtName, params);
      }
      this._track(evtName, params);
    }
  }, {
    key: "addEventsQueue",
    value: function addEventsQueue(eventName, params) {
      this.eventQueue.push({
        event: eventName,
        params
      });
      if (this.eventQueue.length >= this._options.maxQueueCount) {
        this.sendEventsQueue();
      }
    }
  }, {
    key: "sendEventsQueue",
    value: function sendEventsQueue() {
      while (this.eventQueue.length > 0) {
        var item = this.eventQueue.pop();
        this._track(item.event, item.params);
      }
    }
  }, {
    key: "startWaitingStatus",
    value: function startWaitingStatus(startTime, costTime) {
      this.appendStallInfo("start", startTime);
      this.updateCurBuffer("startWaitingStatus");
      this.onOneEvent({
        costTime,
        end_type: "waitstart"
      }, {}, 2);
    }
  }, {
    key: "triggerTask",
    value: function triggerTask() {
      var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "start";
      var url = arguments.length > 1 ? arguments[1] : void 0;
      log("triggerTask>>", type);
      url = url || this.player.src;
      var isSrcEmpty = checkVideoSrcIsEmpty(url);
      !isSrcEmpty && this.vtype.indexOf("MP4") > -1 && this.task && this.task.trigger(url, type);
    }
  }, {
    key: "appendStallInfo",
    value: function appendStallInfo() {
      var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "start";
      var time = arguments.length > 1 ? arguments[1] : void 0;
      var endType = arguments.length > 2 ? arguments[2] : void 0;
      if (!this.exInfo.stall) {
        this.exInfo.stall = [];
      }
      var stall = this.exInfo.stall;
      if (type === "start") {
        if (stall.length > 6) {
          stall.splice(0, stall.length - 6);
        }
        var buf = this.buffers.curBuffer;
        stall.push({
          start: time,
          end: -1,
          endType: "waitstart",
          cost: 0,
          cur: this.cur_play_pos,
          buf_s: buf.buf_s_pos,
          // 缓存开始点
          buf_e: buf.buf_e_pos,
          // 缓存结束点
          buf_i: buf.buf_include
          // 当前缓存是否包含当前播放时间
        });
      } else if (type === "end") {
        var i = stall.length - 1;
        if (i < 0) {
          return;
        }
        if (stall[i].end < 0) {
          stall[i].end = time;
          stall[i].endType = endType;
          stall[i].cost = time - stall[i].start;
        }
      }
      log("appendStallInfo", stall);
    }
  }, {
    key: "suspendWaitingStatus",
    value: function suspendWaitingStatus(endType) {
      var now = nowTime();
      var playlogs = this.playlogs, resLogs = this.resLogs, stall = this.stall, inWaitingStart = this.inWaitingStart;
      if (inWaitingStart <= 0 || this.isSeeking || playlogs.vt <= 0) {
        return;
      }
      log("suspendWaitingStatus>>".concat(endType, "|costTime:").concat(now - inWaitingStart, " isSeeking:").concat(this.isSeeking));
      this.appendStallInfo("end", now, endType);
      if (now - inWaitingStart > MIN_WAITIONG) {
        var costTime = now - this.inWaitingStart;
        playlogs.bc++;
        if (this.checkInBuffer(this.player.currentTime)) {
          playlogs.de_bu_acu_t += costTime;
          playlogs.dbc++;
        } else {
          playlogs.nbc++;
          playlogs.n_bu_acu_t += costTime;
        }
        resLogs.bc++;
        playlogs.bu_acu_t += costTime;
        resLogs.bu_acu_t += costTime;
        stall.end = this.cur_play_pos;
        stall.cost = costTime;
        stall.acc += stall.cost;
        if (stall.sc === 1) {
          stall.endf = this.cur_play_pos;
        }
        if (this.player.abrInstance && !this.isSeeking && this.playlogs.vt) {
          var abrInst = this.player.abrInstance;
          this.abrInfo.abr_event_info.video_stall.push({
            local_time_ms: (/* @__PURE__ */ new Date()).getTime(),
            stall_duration: parseFloat((costTime / 1e3).toFixed(2)),
            // 卡顿时长，单位s
            buffer_length: abrInst.bufferLength,
            internet_speed: abrInst.downloadSpeed,
            now_bitrate: abrInst.nowBitrate,
            play_speed: this.player.playbackRate,
            is_abr: abrInst.isCurrentInAbr ? 1 : 0
            // 是否在abr档位
          });
        }
        this.onOneEvent({
          costTime,
          end_type: "waitend_".concat(endType) || "waitend"
        }, {}, 2);
      }
      this._endType = "";
      this.load_state = LOAD_STATES.PLAYABLE;
      this.inWaitingStart = 0;
      this.waitStartTime = 0;
      window.clearTimeout(this.stallIntervalId);
      this.stallIntervalId = null;
    }
  }, {
    key: "suspendSeekStatus",
    value: function suspendSeekStatus(endType) {
      var needSendLog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      if (!this.isSeeking) {
        return;
      }
      var seekLog = this.seekLog, resLogs = this.resLogs, player = this.player;
      var costTime = nowTime() - seekLog.lastSeekStartTime;
      log("suspendSeekStatus>>", "".concat(endType, " currentTime:").concat(player.currentTime, " costTime:").concat(costTime, " sat:").concat(seekLog.sat, " resLogs.sat:").concat(resLogs.sat));
      seekLog.intervalId && window.clearTimeout(seekLog.intervalId);
      seekLog.intervalId = null;
      this.isSeeking = false;
      var operaType = this._endType = "seek";
      var stateBefore = seekLog.seekBefore;
      var stateAfter = (player.currentTime || 0).toString();
      seekLog.sc++;
      seekLog.sat += costTime > MAX_COST ? 0 : costTime;
      resLogs.sc++;
      resLogs.sat += costTime > MAX_COST ? 0 : costTime;
      if (costTime > MAX_COST) {
        costTime = MAX_COST;
      }
      this.updateSeekPt(true);
      if (!this.closeSeekLog && needSendLog) {
        this.onOneOperator({
          costTime,
          operaType,
          stateBefore,
          stateAfter,
          endType
        });
      }
    }
  }, {
    key: "setPt",
    value: function setPt() {
      var playlogs = this.playlogs;
      this.startStep = 1;
      if (!playlogs.pt && this.player.currentTime) {
        this.isSeeking = true;
      }
      if (!playlogs.pt) {
        playlogs.pt = curTimestamp();
        log("setPt", "init pt :".concat(playlogs.pt, ", document.visibilityState:").concat(document.visibilityState));
      }
    }
  }, {
    key: "setVt",
    value: function setVt() {
      var playlogs = this.playlogs;
      if (this.startStep === 1) {
        if (!playlogs.vt) {
          playlogs.vt = curTimestamp();
          log("setVt: first frame inited", "vt-pt:".concat(playlogs.vt - playlogs.pt, " vt-nt:").concat(playlogs.vt - playlogs.nt));
        }
        this.startStep = 2;
      }
    }
  }, {
    key: "setBr",
    value: function setBr(endType) {
      var playlogs = this.playlogs;
      if (playlogs.vt > 0) {
        if (playlogs.br === 0) {
          playlogs.fbrt = endType || "";
        }
        playlogs.br++;
      }
    }
  }, {
    key: "codecType",
    get: function get() {
      var player = this.player;
      if (player && player.config && player.config.codecType) {
        return player.config.codecType;
      } else {
        return this._options.codec_type || "h264";
      }
    }
    // params start,较新URL
  }, {
    key: "url",
    get: function get() {
      var player = this.player;
      return player && player.config ? player.config.url : "";
    }
    // video id
  }, {
    key: "vid",
    get: function get() {
      var player = this.player;
      return player && player.config ? player.config.vid : "";
    }
  }, {
    key: "bc",
    get: function get() {
      return this.playlogs.bc;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "bu_acu_t",
    get: function get() {
      return this.playlogs.bu_acu_t;
    }
    // 启动播放的时间戳
  }, {
    key: "pt",
    get: function get() {
      return this.playlogs.pt || curTimestamp();
    }
  }, {
    key: "vt",
    get: function get() {
      var _this$playlogs = this.playlogs, vt = _this$playlogs.vt, pt = _this$playlogs.pt;
      return pt > 0 ? vt : 0;
    }
  }, {
    key: "fvt",
    get: function get() {
      var _this$playlogs2 = this.playlogs, vt = _this$playlogs2.vt, pt = _this$playlogs2.pt;
      var ret = 0;
      if (vt > 0 && pt > 0) {
        ret = parseInt(vt - pt, 10);
      }
      return ret > MAX_FVT ? MAX_FVT : ret;
    }
  }, {
    key: "nvt",
    get: function get() {
      var _this$playlogs3 = this.playlogs, vt = _this$playlogs3.vt, nt = _this$playlogs3.nt;
      if (vt > 0 && nt > 0) {
        return parseInt(vt - nt, 10);
      }
      return 0;
    }
    /**
     * @description 获取渲染帧率信息
     * @returns
     */
  }, {
    key: "getFrameInfo",
    value: function getFrameInfo() {
      if (this.player && this.player.videoFrameInfo) {
        var _this$player$videoFra = this.player.videoFrameInfo, dropped = _this$player$videoFra.dropped, corrupted = _this$player$videoFra.corrupted, droppedRate = _this$player$videoFra.droppedRate, total = _this$player$videoFra.total;
        return {
          f_total: total,
          drop_count: dropped,
          drop_rate: parseInt(droppedRate * 100, 10),
          corrupted
        };
      } else {
        return {
          f_total: 0,
          drop_count: 0,
          drop_rate: 0,
          corrupted: 0
        };
      }
    }
  }, {
    key: "vd",
    get: function get() {
      var player = this.player;
      if (player.duration && typeof player.duration === "number" && player.duration > 0) {
        return parseInt(player.duration * 1e3, 10);
      } else if (player.config.duration && typeof player.config.duration === "number") {
        return parseInt(player.config.duration * 1e3, 10);
      }
      return 0;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "cur_play_pos",
    get: function get() {
      return parseInt(this.player.currentTime * 1e3, 10);
    }
  }, {
    key: "volume",
    get: function get() {
      return this.player.volume;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "buffer_time",
    get: function get() {
      var buf = 0;
      try {
        var range = this.player.getBufferedRange();
        buf = range[1] - range[0];
      } catch (e) {
        buf = 0;
      }
      return buf;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "player_created_t",
    get: function get() {
      return this._playerCreatedTime;
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.player.playbackRate;
    }
  }, {
    key: "mute",
    get: function get() {
      return this.player.muted ? 0 : 1;
    }
  }, {
    key: "videoWidth",
    get: function get() {
      var player = this.player;
      return player && player.video ? player.video.videoWidth : 0;
    }
  }, {
    key: "videoHeight",
    get: function get() {
      var player = this.player;
      return player && player.video ? player.video.videoHeight : 0;
    }
  }, {
    key: "preload",
    get: function get() {
      var player = this.player;
      return player && player.video ? player.video.preload : false;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "initial_url",
    get: function get() {
      var currentSrc = this.player.currentSrc;
      if (currentSrc.indexOf("blob:") > -1 && this.urlLog.initial_url) {
        return this.urlLog.initial_url;
      } else {
        return checkVideoSrcIsEmpty(currentSrc) ? "" : currentSrc;
      }
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "initial_host",
    get: function get() {
      var currentSrc = this.player.currentSrc;
      if (currentSrc.indexOf("blob:") > -1 && this.urlLog.initial_host) {
        return this.urlLog.initial_host;
      } else {
        return getHostFromUrl(checkVideoSrcIsEmpty(currentSrc) ? "" : currentSrc);
      }
    }
  }, {
    key: "curHeaders",
    get: function get() {
      var player = this.player, task = this.task;
      if (player && player.__dash__ && player.__dash__.curReqVideoSegInfo) {
        var headers = player.__dash__.curReqVideoSegInfo.headers || {};
        return transformHeader(headers);
      } else if (task) {
        return task.headers;
      }
      return {};
    }
  }, {
    key: "curStatus",
    get: function get() {
      var task = this.task, vtype = this.vtype, netLog = this.netLog;
      if (vtype.indexOf("MP4") > -1) {
        return task ? task.status : 0;
      } else {
        return netLog.status;
      }
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "play_type",
    get: function get() {
      return 0;
    }
    // 清晰度 分辨率
  }, {
    key: "resolution",
    get: function get() {
      var curDefinition = this.player.curDefinition;
      return curDefinition ? "".concat(curDefinition.definition) : this.resLogs.df;
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this._sessionId;
    }
    // 是否播放完
  }, {
    key: "finish",
    get: function get() {
      return this.isEnded ? 1 : 0;
    }
    /**
     * @description 结束类型
     * @type { string }
     */
  }, {
    key: "end_type",
    get: function get() {
      return this._endType;
    }
    /**
     * @description 当前播放器实时下载的平均速度
     * @type { number }
     */
  }, {
    key: "avgSpeed",
    get: function get() {
      return this.player && this.player.avgSpeed ? this.player.avgSpeed : 0;
    }
    /**
     * @description 当前播放器实时下载速度
     * @type { number }
     */
  }, {
    key: "realSpeed",
    get: function get() {
      return this.player && this.player.realTimeSpeed ? this.player.realTimeSpeed : 0;
    }
    /**
     * @description 当前播放器mse的队列长度
     * @type { number }
     */
  }, {
    key: "mp4MseOpLength",
    get: function get() {
      if (!this.player || !this.player.plugins) {
        return -1;
      }
      var mp4 = this.player.plugins.mp4encryptplayer;
      if (mp4) {
        return mp4.opQueueLen || 0;
      }
      return -1;
    }
    /**
     * @description 当前mp4正在加载的信息
     * @type string  数据格式为 timeStart,timeEnd,rangeStart,rangeEnd
     */
  }, {
    key: "mp4LoadSegmentTimeRange",
    get: function get() {
      if (!this.player || !this.player.plugins) {
        return "";
      }
      var mp4 = this.player.plugins.mp4encryptplayer;
      if (mp4) {
        return mp4.loadSegmentTimeRange.join(",");
      }
      return "";
    }
    /**
     * 当前播放器命中预加载的情况
     * @type {{
     *  hit: number, // 0-未命中 1-命中
     *  duration: 0, // 预加载时长
     *  length: 0 // 预加载数据长度
     * }}
     */
  }, {
    key: "preLoadData",
    get: function get() {
      if (!this.player || !this.player.plugins) {
        return [];
      }
      var mp4 = this.player.plugins.mp4encryptplayer;
      if (mp4 && mp4.preLoadData) {
        return {
          hit: 1,
          duration: mp4.preLoadData.duration,
          length: mp4.preLoadData.byteLength
        };
      }
      var stat = this.player.stat || {};
      if (stat.preLoadData) {
        var length = stat.preLoadData.length;
        return {
          hit: length > 0,
          length
        };
      }
      return {
        hit: 0,
        duration: 0,
        length: 0
      };
    }
    /**
     * 当前播放器的预加载状态
     * @returns { number } 预加载状态，0没有 1队列中 2当前正在预加载
     */
  }, {
    key: "preloadState",
    get: function get() {
      if (!this.player || !this.player.plugins) {
        return 0;
      }
      if (typeof this.player.preloadState !== "undefined") {
        return this.player.preloadState || 0;
      }
      var mp4 = this.player.plugins.mp4encryptplayer;
      if (mp4 && mp4.preloadState) {
        return mp4.preloadState;
      }
      return 0;
    }
    /**
     * 获取当前播放视频的码率
     * @type { number }
     */
  }, {
    key: "curBitrate",
    get: function get() {
      var _this$player5 = this.player, config = _this$player5.config, curDefinition = _this$player5.curDefinition;
      if (curDefinition && curDefinition.bitrate) {
        return curDefinition.bitrate;
      } else if (config.defaultBitrate) {
        return config.defaultBitrate;
      }
      return 0;
    }
    // 音频/视频的当前就绪状态
  }, {
    key: "videoReadyState",
    get: function get() {
      var player = this.player;
      return player && player.video ? player.video.readyState : -1;
    }
    // 显示出用户是否正在视频中寻址
  }, {
    key: "videoSeeking",
    get: function get() {
      var player = this.player;
      return player && player.video && player.video.seeking ? 1 : 0;
    }
    // 检查视频是否已暂停
  }, {
    key: "videoPaused",
    get: function get() {
      var player = this.player;
      return player && player.video && player.video.paused ? 1 : 0;
    }
  }, {
    key: "switchResolutionCount",
    get: function get() {
      return this.resLogs.switch_count;
    }
  }, {
    key: "isError",
    get: function get() {
      return this.player._isError || this.player.video.error;
    }
  }, {
    key: "isPlaying",
    get: function get() {
      return hasClass(this.player.root, "xgplayer-playing");
    }
  }, {
    key: "isStop",
    get: function get() {
      return hasClass(this.player.root, "xgplayer-ended") || hasClass(this.player.root, "xgplayer-nostart");
    }
  }, {
    key: "isPause",
    get: function get() {
      return hasClass(this.player.root, "xgplayer-pause");
    }
  }, {
    key: "isLoading",
    get: function get() {
      return hasClass(this.player.root, "xgplayer-isloading");
    }
    // error_stage出错时的播放阶段，beforePlay/playing
  }, {
    key: "es",
    get: function get() {
      return this.isPlaying ? "playing" : "beforePlay";
    }
  }, {
    key: "lt",
    get: function get() {
      var tmp = 0;
      if (this.vt === 0) {
        log("lt init", this.playlogs.lt);
        tmp = curTimestamp();
      }
      return tmp;
    }
  }, {
    key: "lpt",
    get: function get() {
      return this.lt ? this.lt - this.pt : 0;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "playback_state",
    get: function get() {
      if (this.isError) {
        return PLAYBACK_STATE.ERROR;
      }
      if (this.isStop) {
        return PLAYBACK_STATE.STOP;
      }
      if (this.isPause) {
        return PLAYBACK_STATE.PAUSE;
      }
      if (this.isLoading) {
        return PLAYBACK_STATE.LOADING;
      }
      return PLAYBACK_STATE.PLAYING;
    }
    // eslint-disable-next-line camelcase
  }, {
    key: "is_start_play_automatically",
    get: function get() {
      return "".concat(this.isAutoplay);
    }
    /**
     * @description 用户累计播放时长
     * @return { number }
     *
     */
  }, {
    key: "watchDur",
    get: function get() {
      var player = this.player, playlogs = this.playlogs;
      var _t = player.cumulateTime ? player.cumulateTime : computeWatchDur(playlogs.played);
      return _t >= 0 ? _t : 0;
    }
  }, {
    key: "vtype",
    get: function get() {
      if (this.__vtype) {
        return this.__vtype;
      }
      var _vtype = this.player ? this.player.vtype || this.player.config.vtype : "";
      return _vtype ? _vtype : this.player.dash ? "DASH" : this._options.vtype || "MP4";
    },
    set: function set(value) {
      this.__vtype = value;
    }
  }, {
    key: "envInfo",
    get: function get() {
      return this._envInfo;
    },
    set: function set(value) {
      if (!value) {
        return;
      }
      this._envInfo = value;
    }
  }, {
    key: "getPlayerExt",
    value: function getPlayerExt() {
      var ext = this.player.ext;
      if (ext) {
        return ext;
      }
    }
  }, {
    key: "watingCost",
    get: function get() {
      if (this.inWaitingStart > 0) {
        var costTime = nowTime() - this.inWaitingStart;
        return costTime > MAX_COST ? 0 : costTime;
      } else {
        return 0;
      }
    }
  }, {
    key: "videoNetworkState",
    get: function get() {
      var player = this.player;
      return player && player.video ? player.video.networkState : -1;
    }
  }, {
    key: "eagleid",
    get: function get() {
      var player = this.player;
      if (player && player.__dash__ && player.__dash__.curReqVideoSegInfo) {
        var headers = player.__dash__.curReqVideoSegInfo.headers || {};
        return headers.eagleid;
      }
      return "";
    }
  }, {
    key: "initial_type",
    get: function get() {
      var config = this.player.config || {};
      if (config && config.vodLogOpts && config.vodLogOpts.currentDashType !== void 0) {
        return parseInt(config.vodLogOpts.currentDashType, 10);
      }
      return -1;
    }
    /**
     * range请求  segment_base
     * 分片文件请求 segment_template
     */
  }, {
    key: "dynamicType",
    get: function get() {
      var player = this.player;
      if (this.__dt) {
        return this.__dt;
      } else if (player && player.__dash__ && player.__dash__.dash && player.__dash__.dash.mpd) {
        this.__dt = player.__dash__.dash.mpd.dashType;
        return this.__dt;
      } else {
        return "";
      }
    }
    /**
     * @description 更新当前buffer
     */
  }, {
    key: "updateBuffers",
    value: function updateBuffers() {
      var buffered = this.player.buffered;
      var buffers = [];
      if (!buffered || buffered.length < 1) {
        this.buffers.allBuffer = [];
        return;
      }
      for (var i = 0; i < buffered.length; i++) {
        var s = parseInt(buffered.start(i) * 1e3, 10);
        var e = parseInt(buffered.end(i) * 1e3, 10);
        buffers.push({
          s,
          e
        });
      }
      this.buffers.allBuffer = buffers;
    }
    /**
     * 检测当前buffer和currentTime之间的关系
     */
  }, {
    key: "updateCurBuffer",
    value: function updateCurBuffer(state) {
      var _this$player6 = this.player, buffered = _this$player6.buffered, currentTime = _this$player6.currentTime;
      var buffer = {
        buf_s_pos: 0,
        // 缓存开始点
        buf_e_pos: 0,
        // 缓存结束点
        buf_include: 0,
        // 当前缓存是否包含当前播放时间
        buf_diff: 0
      };
      if (!buffered || buffered.length < 1) {
        return buffer;
      }
      var diff = -1, index = -1;
      var ct = parseInt(currentTime * 1e3, 10);
      for (var i = buffered.length - 1; i > -1; i--) {
        var start = parseInt(buffered.start(i) * 1e3, 10);
        var end = parseInt(buffered.end(i) * 1e3, 10);
        if (ct >= start && ct <= end) {
          buffer.buf_include = 1;
          buffer.buf_s_pos = start;
          buffer.buf_e_pos = end;
          buffer.buf_diff = end - ct;
          break;
        } else {
          if (ct < start && (diff < 0 || start - ct < diff)) {
            diff = start - ct;
            index = i;
          } else if (ct > end && (diff < 0 || ct - end < diff)) {
            diff = ct - end;
            index = i;
          }
        }
      }
      if (buffer.buf_include !== 1) {
        if (index < 0) {
          index = buffered.length - 1;
        }
        buffer.buf_s_pos = parseInt(buffered.start(index) * 1e3, 10);
        buffer.buf_e_pos = parseInt(buffered.end(index) * 1e3, 10);
      }
      this.buffers.curBuffer = buffer;
    }
  }, {
    key: "checkInBuffer",
    value: function checkInBuffer(currentTime) {
      var diff = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      var buffered = this.player.buffered;
      if (!buffered) {
        return false;
      }
      currentTime = parseInt(currentTime * 1e3, 10);
      for (var i = 0; i < buffered.length; i++) {
        var start = parseInt(buffered.start(i) * 1e3, 10), end = parseInt(buffered.end(i) * 1e3, 10) + diff;
        if (currentTime > start && currentTime < end) {
          return true;
        }
      }
      return false;
    }
    /**
     * @description 获取pcdn想下载信息
     */
  }, {
    key: "getPCDNStat",
    value: function getPCDNStat() {
      if (this.player && this.player.pcdnVVStat) {
        var d = this.player.pcdnVVStat;
        var try_req_num = d.try_req_num, req_node_succ = d.req_node_succ, conn_req_num = d.conn_req_num, has_ret_node = d.has_ret_node, conn_fail_num = d.conn_fail_num, conn_jump_num = d.conn_jump_num, rest = _objectWithoutProperties(d, _excluded);
        return _objectSpread2({
          try_req: try_req_num,
          req_succ: req_node_succ,
          has_ret: has_ret_node,
          conn_req: conn_req_num,
          conn_fail: conn_fail_num,
          conn_jump: conn_jump_num
        }, rest);
      } else {
        return {};
      }
    }
    /**
     * @description 获取当前视频码率、文件大小等信息
     */
  }, {
    key: "updateVideoSize",
    value: function updateVideoSize() {
      var _options = this._options, player = this.player, resLogs = this.resLogs;
      var vs = 0;
      var bitrate = 0;
      if (player.__dash__ && player.__dash__.dash && player.__dash__.dash.mpd.mediaList) {
        var videoList = player.__dash__.dash.mpd.mediaList.video;
        var videoItem = videoList[videoList.selectedIdx];
        log("updateVideoSize》》videoItem", videoItem);
        bitrate = videoItem ? videoItem.bitrate || videoItem.bandwidth : 0;
        vs = videoItem ? videoItem.size : 0;
      } else {
        var curDefinition = this.player.curDefinition;
        if (curDefinition) {
          bitrate = curDefinition.bitrate || player.config.bitrate || 0;
          vs = parseInt(curDefinition.bitrate * player.duration / 8, 10);
        } else {
          vs = _options.videoSize || player.config.videoSize || 0;
          bitrate = _options.bitrate || player.config.bitrate || 0;
        }
      }
      log("updateVideoSize", "bitrate:".concat(bitrate, ", vs:").concat(vs));
      if (vs) {
        resLogs.vs = vs;
        resLogs.vis = parseInt(vs / player.duration, 10);
        resLogs.bitrate = bitrate || resLogs.vis;
      }
    }
  }, {
    key: "updateVds",
    value: function updateVds() {
      var resLogs = this.resLogs, playlogs = this.playlogs, player = this.player;
      if (resLogs.vis === 0) {
        log("updateVds", "vis:".concat(resLogs.vis));
        return;
      }
      var pdur = parseInt(computeWatchDur(playlogs.played) / 1e3, 10);
      var buf = player.buffered;
      var bdur = 0;
      for (var i = 0; i < buf.length; i++) {
        bdur += parseInt(buf.end(i) - buf.start(i), 10);
      }
      log("updateVds", "pdur:".concat(pdur, " bdur:").concat(bdur, " \n         lbuf:").concat(resLogs.lbuf, " lplayed:").concat(resLogs.lplayed, " bitrate: ").concat(resLogs.bitrate, " vis:").concat(resLogs.vis, " vs:").concat(resLogs.vs));
      resLogs.lplayed = pdur;
      resLogs.lbuf = bdur;
    }
    /**
     * 加密信息上报,  encryptedType: 0 不加密播放
     *               encryptedType: 1  加密 EME 播放
     *               encryptedType: 2  加密 JS解密 播放
     */
  }, {
    key: "encryptedInfo",
    get: function get() {
      return this.player.encryptedInfo || {
        encryptedType: 0
      };
    }
  }], [{
    key: "TEA_ID",
    get: function get() {
      return TEA_ID;
    },
    set: function set(value) {
      TEA_ID = value;
      LS_KEY = "__tea_cache_tokens_".concat(TEA_ID);
    }
  }, {
    key: "AB_SDK_VERSION",
    get: (
      // 获取实验id
      function get() {
        return AB_SDK_VERSION;
      }
    ),
    set: function set(value) {
      AB_SDK_VERSION = typeOf(value) === "Array" ? value.join(",") : value;
    }
  }, {
    key: "Collector",
    set: function set(value) {
      Collector = value;
    }
  }, {
    key: "defaultConfig",
    value: function defaultConfig() {
      return {
        line_app_id: "",
        line_user_id: "",
        isTask: false,
        // 是否自动起异常检测服务
        codec_type: "",
        // 视频解码器类型名称，如 h264，h265
        playerCoreVersion: "",
        // 播放器内核版本号
        playerVersion: "",
        // 播放器或者播放插件版本号
        start_time: 0,
        // 视频起播时候的起始位置
        maxQueueCount: 5,
        // 埋点合并发送最大条数
        channel: "cn",
        // 数据上报渠道，非必传，默认为cn(国内)； 可选值：va(美东) sg(新加坡)
        channelDomain: "",
        // tea埋点发送域名
        absdkVersion: "",
        // 实验id 透传
        checkByInnerLog: true,
        // 是用xgplayer内置的log做监听
        drm_type: 0,
        // 0:非drm视频，1：drm视频
        vtype: "MP4",
        // video model中的视频类型字段，HLS/DASH/MP4/FLV
        tag: "普通视频",
        // 长视频、小视频、普通视频、miniapp
        subtag: "",
        // 小程序使用，非小程序场景不传
        dynamic_type: "",
        // DASH播放器，能获取是传入
        // enable_bash: 0, // 是否使用bash  0或1, DASH播放器时传入
        sendLocalCallback: function sendLocalCallback() {
        },
        disableLocalCache: false,
        // 是否禁用localStorage暂时缓存onPlay逻辑，默认为false
        closeResolutionLog: false,
        // 是否关闭清晰度切换埋点
        closeSeekLog: false,
        // 是否关闭seek操作发送的logger
        needXhrCheck: false,
        // 出现错误的时候是否需要对播放地址做检测
        trackerConfig: {},
        envInfo: {}
      };
    }
  }]);
  return XGPlayerAppLogger2;
}();
export {
  XGPlayerAppLogger as default
};
